document.addEventListener('DOMContentLoaded', function () {
  var roots = document.querySelectorAll('[data-sell-device-root]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    initSellDeviceForm(root);
  });
});

function initSellDeviceForm(root) {
  if (!root || root.getAttribute('data-sell-device-initialized') === 'true') return;
  root.setAttribute('data-sell-device-initialized', 'true');

  var jsonNode = root.querySelector('[data-sell-device-data]');
  if (!jsonNode) return;

  var rawData;
  try {
    rawData = JSON.parse(jsonNode.textContent);
  } catch (error) {
    console.error('Sell device form data could not be parsed.', error);
    return;
  }

  var catalogSettings = rawData && rawData.settings ? rawData.settings : {};
  var data = normalizeCatalogData(rawData);
  var minimumPhotoCount = parseInt(root.getAttribute('data-min-device-photos'), 10) || 6;
  var requiredPhotoMinimum = 1;
  var maximumPhotoCount = parseInt(root.getAttribute('data-max-device-photos'), 10) || 10;
  if (maximumPhotoCount < requiredPhotoMinimum) maximumPhotoCount = requiredPhotoMinimum;

  var steps = Array.from(root.querySelectorAll('[data-step]'));
  var progressItems = Array.from(root.querySelectorAll('[data-progress-step]'));
  var notice = root.querySelector('[data-step-notice]');
  var selectedPills = root.querySelector('[data-selected-pills]');
  var quickDeviceGrid = root.querySelector('[data-quick-device-grid]');
  var formFlow = root.querySelector('[data-form-flow]');

  var deviceOptions = root.querySelector('[data-device-options]');
  var brandOptions = root.querySelector('[data-brand-options]');
  var brandSearchInput = root.querySelector('[data-brand-search]');
  var modelSearchInput = root.querySelector('[data-model-search]');
  var seriesWrap = root.querySelector('[data-series-wrap]');
  var seriesChips = root.querySelector('[data-series-chips]');
  var modelGrid = root.querySelector('[data-model-grid]');
  var variantGrid = root.querySelector('[data-variant-grid]');
  var colorGrid = root.querySelector('[data-color-grid]');
  var customColorWrap = root.querySelector('[data-custom-color-wrap]');
  var customColorInput = root.querySelector('[data-custom-color]');
  var conditionGrid = root.querySelector('[data-condition-grid]');
  var batteryGrid = root.querySelector('[data-battery-grid]');
  var batteryWrap = root.querySelector('[data-battery-wrap]');
  var detailPanel = root.querySelector('[data-device-detail-panel]');
  var continueButton = root.querySelector('[data-go-pickup]');
  var catalogDetails = root.querySelector('[data-catalog-details]');
  var otherDetails = root.querySelector('[data-other-details]');
  var modelSection = root.querySelector('[data-model-section]');
  var otherBrandInput = root.querySelector('[data-other-brand]');
  var otherModelInput = root.querySelector('[data-other-model]');
  var otherMemoryInput = root.querySelector('[data-other-memory]');
  var otherColorInput = root.querySelector('[data-other-color]');
  var otherConditionGrid = root.querySelector('[data-other-condition-grid]');
  var otherBatteryGrid = root.querySelector('[data-other-battery-grid]');

  var variantThumb = root.querySelector('[data-variant-thumb]');
  var selectedModelTitle = root.querySelector('[data-selected-model-title]');
  var selectedModelHelper = root.querySelector('[data-selected-model-helper]');

  var summaryProduct = root.querySelector('[data-summary-product]');
  var summaryBrand = root.querySelector('[data-summary-brand]');
  var summarySeries = root.querySelector('[data-summary-series]');
  var summaryModel = root.querySelector('[data-summary-model]');
  var summaryVariant = root.querySelector('[data-summary-variant]');
  var summaryColor = root.querySelector('[data-summary-color]');
  var summaryCondition = root.querySelector('[data-summary-condition]');
  var summaryBattery = root.querySelector('[data-summary-battery]');
  var summaryPhotos = root.querySelector('[data-summary-photos]');

  var photoGuideModal = root.querySelector('[data-photo-guide-modal]');
  var photoGuideCloseButtons = Array.from(root.querySelectorAll('[data-photo-guide-close]'));
  var photoGuideDoneButton = root.querySelector('[data-photo-guide-done]');
  var photoSlotInputs = Array.from(root.querySelectorAll('[data-photo-slot-input]'));
  var photoSlotButtons = Array.from(root.querySelectorAll('[data-photo-slot-button]'));
  var photoSlotRemoveButtons = Array.from(root.querySelectorAll('[data-photo-slot-remove]'));
  var photoOverallLabel = root.querySelector('[data-photo-overall-label]');
  var photoOverallTrack = root.querySelector('[data-photo-overall-track]');
  var photoOverallBar = root.querySelector('[data-photo-overall-bar]');
  var photoSlotError = root.querySelector('[data-photo-slot-error]');
  var photoSlotFiles = new Array(minimumPhotoCount).fill(null);
  var photoSlotPreviewUrls = new Array(minimumPhotoCount).fill('');
  var photoSlotsSynced = false;
  var nativePhotoSelectedCount = 0;
  var allowNativePhotoPickerOnce = false;
  var nativePhotoObserver = null;
  var pendingPhotoInput = null;
  var photoGuideLastFocused = null;

  var nerdyHost = root.querySelector('[data-nerdy-form-host]');
  var nerdyLoading = root.querySelector('[data-nerdy-loading]');
  var nerdySuccess = root.querySelector('[data-nerdy-success]');
  var nerdyObserver = null;
  var nerdyPollTimer = null;
  var boundNerdyRoots = [];
  var lastNerdyFields = null;
  var successShown = false;
  // Success detection is armed only after a submit action in this page load.
  // This prevents Nerdy Form's previously-rendered success state from
  // reopening our custom success message after a browser refresh.
  var nerdySubmissionPending = false;
  var nerdySubmissionStartedAt = 0;
  var nerdyPreSubmitFieldCount = 0;
  var nerdySuccessCheckTimer = null;
  var nerdySuccessTimeoutTimer = null;
  var nerdyPageObserver = null;
  var nerdyConnectQueued = false;
  var nerdyConnected = false;

  var autoAdvanceTimer = null;
  var mobileDetailStage = 'series';

  var state = {
    step: 1,
    device: 'phone',
    brand: '',
    seriesFilter: '',
    modelKey: '',
    modelTitle: '',
    variantKey: '',
    variantLabel: '',
    color: '',
    customColor: '',
    condition: '',
    batteryHealth: '',
    otherBrand: '',
    otherModel: '',
    otherMemory: '',
    otherColor: '',
    otherCondition: '',
    otherBatteryHealth: '',
    brandSearch: '',
    modelSearch: '',
    submissionReference: createSubmissionReference(),
    submittedAt: ''
  };

  resetNerdySuccessState();
  renderBrands();
  renderOtherConditions();
  renderOtherBatteryHealth();
  bindEvents();
  initPhotoGuidePopup();
  initNerdyIntegration();
  goToStep(1, true);
  refreshUi();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resetNerdySuccessState();
      photoSlotsSynced = false;
      goToStep(1, true);
      updatePhotoSlotUi();
      refreshUi();
    }
  });

  function bindEvents() {
    root.addEventListener('click', function (event) {
      var brandBtn = event.target.closest('[data-brand-value]');
      if (brandBtn) {
        selectBrand(brandBtn.getAttribute('data-brand-value'));
        return;
      }

      var chipBtn = event.target.closest('[data-series-value]');
      if (chipBtn) {
        state.seriesFilter = chipBtn.getAttribute('data-series-value');
        mobileDetailStage = 'model';
        resetDeviceDetailSelections(true);
        renderSeriesChips();
        renderModels();
        renderVariants();
        renderColors();
        renderConditions();
        renderBatteryHealth();
        refreshUi();
        if (modelSection) modelSection.hidden = false;
        scrollToModelGrid();
        return;
      }

      var modelBtn = event.target.closest('[data-model-key]');
      if (modelBtn) {
        state.modelKey = modelBtn.getAttribute('data-model-key');
        state.modelTitle = modelBtn.getAttribute('data-model-title') || '';
        mobileDetailStage = 'details';
        state.variantKey = '';
        state.variantLabel = '';
        state.color = '';
        state.customColor = '';
        if (customColorInput) customColorInput.value = '';
        state.condition = '';
        state.batteryHealth = '';
        renderModels();
        renderVariants();
        renderColors();
        renderConditions();
        renderBatteryHealth();
        refreshUi();
        scrollToDeviceDetailPanel();
        return;
      }

      var variantBtn = event.target.closest('[data-variant-key]');
      if (variantBtn) {
        state.variantKey = variantBtn.getAttribute('data-variant-key');
        state.variantLabel = variantBtn.getAttribute('data-variant-label') || '';
        renderVariants();
        refreshUi();
        return;
      }

      var colorBtn = event.target.closest('[data-color-value]');
      if (colorBtn) {
        state.color = colorBtn.getAttribute('data-color-value') || '';

        if (state.color !== 'Other') {
          state.customColor = '';
          if (customColorInput) customColorInput.value = '';
        }

        renderColors();
        refreshUi();

        if (state.color === 'Other' && customColorInput) {
          window.setTimeout(function () {
            customColorInput.focus();
          }, 30);
        }
        return;
      }

      var conditionBtn = event.target.closest('[data-condition-value]');
      if (conditionBtn) {
        state.condition = conditionBtn.getAttribute('data-condition-value') || '';
        renderConditions();
        refreshUi();
        return;
      }

      var batteryBtn = event.target.closest('[data-battery-value]');
      if (batteryBtn) {
        state.batteryHealth = batteryBtn.getAttribute('data-battery-value') || '';
        renderBatteryHealth();
        refreshUi();
        return;
      }

      var otherConditionBtn = event.target.closest('[data-other-condition-value]');
      if (otherConditionBtn) {
        state.otherCondition = otherConditionBtn.getAttribute('data-other-condition-value') || '';
        renderOtherConditions();
        refreshUi();
        return;
      }

      var otherBatteryBtn = event.target.closest('[data-other-battery-value]');
      if (otherBatteryBtn) {
        state.otherBatteryHealth = otherBatteryBtn.getAttribute('data-other-battery-value') || '';
        renderOtherBatteryHealth();
        refreshUi();
        return;
      }

      var pickupBtn = event.target.closest('[data-go-pickup]');
      if (pickupBtn) {
        if (!validateDeviceDetailsStep()) return;
        goToStep(3);
        return;
      }

      var stepBtn = event.target.closest('[data-go-step]');
      if (stepBtn) {
        var targetStep = Number(stepBtn.getAttribute('data-go-step'));
        if (targetStep < state.step) {
          goToStep(targetStep);
        }
        return;
      }

      var previousButton = event.target.closest('[data-prev-step]');
      if (previousButton) {
        if (handleMobileDeviceDetailBack()) return;
        goToStep(state.step - 1);
      }
    });

    root.addEventListener('input', function (event) {
      if (event.target === brandSearchInput) {
        state.brandSearch = event.target.value.trim().toLowerCase();
        renderBrands();
      }

      if (event.target === modelSearchInput) {
        state.modelSearch = event.target.value.trim().toLowerCase();
        renderModels();
      }

      if (event.target === otherBrandInput) state.otherBrand = event.target.value.trim();
      if (event.target === otherModelInput) state.otherModel = event.target.value.trim();
      if (event.target === otherMemoryInput) state.otherMemory = event.target.value.trim();
      if (event.target === otherColorInput) state.otherColor = event.target.value.trim();
      if (event.target === customColorInput) state.customColor = event.target.value.trim();

      if (
        event.target === otherBrandInput ||
        event.target === otherModelInput ||
        event.target === otherMemoryInput ||
        event.target === otherColorInput ||
        event.target === customColorInput
      ) {
        refreshUi();
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-color-select]')) {
        state.color = event.target.value || '';

        if (state.color !== 'Other') {
          state.customColor = '';
          if (customColorInput) customColorInput.value = '';
        }

        renderColors();
        refreshUi();

        if (state.color === 'Other' && customColorInput) {
          window.setTimeout(function () {
            customColorInput.focus();
          }, 30);
        }
        return;
      }

      if (event.target.matches('[data-condition-select]')) {
        state.condition = event.target.value || '';
        refreshUi();
        return;
      }

      if (event.target.matches('[data-battery-select]')) {
        state.batteryHealth = event.target.value || '';
        refreshUi();
        return;
      }

      if (event.target.matches('[data-other-condition-select]')) {
        state.otherCondition = event.target.value || '';
        refreshUi();
        return;
      }

      if (event.target.matches('[data-other-battery-select]')) {
        state.otherBatteryHealth = event.target.value || '';
        refreshUi();
      }
    });
  }

  function selectDevice(deviceKey) {
    state.device = deviceKey;
    state.brand = '';
    state.seriesFilter = '';
    state.modelKey = '';
    state.modelTitle = '';
    state.variantKey = '';
    state.variantLabel = '';
    state.color = '';
    state.customColor = '';
    if (customColorInput) customColorInput.value = '';
    state.condition = '';
    state.batteryHealth = '';
    state.brandSearch = '';
    state.modelSearch = '';

    if (brandSearchInput) brandSearchInput.value = '';
    if (modelSearchInput) modelSearchInput.value = '';

    renderQuickDevices();
    renderDevices();
    renderBrands();
    renderSeriesChips();
    renderModels();
    renderVariants();
    renderColors();
    renderConditions();
    renderBatteryHealth();
    refreshUi();
    scheduleStepAdvance(2);
  }

  function selectBrand(brandKey) {
    state.device = 'phone';
    state.brand = brandKey;
    state.seriesFilter = brandKey === 'other' ? 'Other / Not listed' : '';
    mobileDetailStage = brandKey === 'other' ? 'details' : 'series';
    state.modelKey = '';
    state.modelTitle = '';
    state.variantKey = '';
    state.variantLabel = '';
    state.color = '';
    state.customColor = '';
    if (customColorInput) customColorInput.value = '';
    state.condition = '';
    state.batteryHealth = '';
    state.modelSearch = '';

    state.otherBrand = '';
    state.otherModel = '';
    state.otherMemory = '';
    state.otherColor = '';
    state.otherCondition = '';
    state.otherBatteryHealth = '';

    if (modelSearchInput) modelSearchInput.value = '';
    if (otherBrandInput) otherBrandInput.value = '';
    if (otherModelInput) otherModelInput.value = '';
    if (otherMemoryInput) otherMemoryInput.value = '';
    if (otherColorInput) otherColorInput.value = '';

    renderBrands();
    renderSeriesChips();
    renderModels();
    renderVariants();
    renderColors();
    renderConditions();
    renderBatteryHealth();
    renderOtherConditions();
    renderOtherBatteryHealth();
    updateBrandDetailMode();
    refreshUi();
    scheduleStepAdvance(2);
  }
  function scheduleStepAdvance(stepNumber) {
    clearTimeout(autoAdvanceTimer);
    autoAdvanceTimer = setTimeout(function () {
      goToStep(stepNumber);
    }, 180);
  }

  function goToStep(stepNumber, skipScroll) {
    if (stepNumber < 1 || stepNumber > steps.length) return;

    state.step = stepNumber;

    steps.forEach(function (stepEl) {
      var current = Number(stepEl.getAttribute('data-step')) === stepNumber;
      stepEl.hidden = !current;
      stepEl.classList.toggle('is-active', current);
    });

    progressItems.forEach(function (item) {
      var itemStep = Number(item.getAttribute('data-progress-step'));
      item.classList.toggle('is-active', itemStep === stepNumber);
      item.classList.toggle('is-complete', itemStep < stepNumber);
    });

    if (stepNumber === 1) renderBrands();
    if (stepNumber === 2) {
      updateBrandDetailMode();
      renderSeriesChips();
      renderModels();
      renderVariants();
      renderColors();
      renderConditions();
      renderBatteryHealth();
      renderOtherConditions();
      renderOtherBatteryHealth();
    }
    if (stepNumber === 3) prepareNerdyForm();

    refreshUi();

    if (!skipScroll) {
      if (
        stepNumber === 3 &&
        window.matchMedia &&
        window.matchMedia('(max-width: 767px)').matches
      ) {
        scrollToPickupContactForm();
      } else {
        scrollToFlow();
      }
    }
  }
  function refreshUi() {
    updateDeviceSelectionState();
    updateMobileDeviceDetailStage();
    updateSelectedPills();
    updateSummary();
    updateContinueState();
    if (lastNerdyFields && lastNerdyFields.deviceDetails) {
      syncNerdyDeviceDetails(lastNerdyFields);
    }
  }
  function isMobileDeviceDetailsView() {
    return !!(
      window.matchMedia &&
      window.matchMedia('(max-width: 767px)').matches
    );
  }

  function updateMobileDeviceDetailStage() {
    if (!catalogDetails) return;

    if (state.brand === 'other' || !state.brand) {
      catalogDetails.removeAttribute('data-mobile-detail-stage');
      return;
    }

    catalogDetails.setAttribute(
      'data-mobile-detail-stage',
      mobileDetailStage
    );
  }

  function handleMobileDeviceDetailBack() {
    if (
      !isMobileDeviceDetailsView() ||
      state.step !== 2 ||
      state.brand === 'other'
    ) {
      return false;
    }

    if (mobileDetailStage === 'details') {
      mobileDetailStage = 'model';
      updateMobileDeviceDetailStage();
      scrollToModelGrid();
      return true;
    }

    if (mobileDetailStage === 'model') {
      mobileDetailStage = 'series';
      updateMobileDeviceDetailStage();
      scrollToSeriesSection();
      return true;
    }

    return false;
  }

  function updateDeviceSelectionState() {
    if (formFlow) formFlow.classList.remove('is-awaiting-device');
    root.classList.add('has-device-selected');
  }
  function renderQuickDevices() {
    if (!quickDeviceGrid) return;

    var deviceKeys = Object.keys(data);
    if (!deviceKeys.length) {
      quickDeviceGrid.innerHTML = '<div class="sell-device__empty">No supported devices were found in the selected Shopify collection.</div>';
      return;
    }

    var html = '';
    deviceKeys.forEach(function (deviceKey) {
      var item = data[deviceKey];
      html += '' +
        '<button type="button" class="sell-device__quick-card' + (state.device === deviceKey ? ' is-active' : '') + '" data-quick-device="' + escapeHtml(deviceKey) + '">' +
          '<span class="sell-device__quick-icon">' + escapeHtml(item.icon || '') + '</span>' +
          '<span>' +
            '<span class="sell-device__quick-title">' + escapeHtml(item.label) + '</span>' +
            '<span class="sell-device__quick-text">' + escapeHtml(item.helper || '') + '</span>' +
          '</span>' +
        '</button>';
    });
    quickDeviceGrid.innerHTML = html;
  }

  function renderDevices() {
    if (!deviceOptions) return;

    var deviceKeys = Object.keys(data);
    if (!deviceKeys.length) {
      deviceOptions.innerHTML = '<div class="sell-device__empty">No supported devices were found in the selected Shopify collection.</div>';
      return;
    }

    var html = '';
    deviceKeys.forEach(function (deviceKey) {
      var item = data[deviceKey];
      html += createMetaCard(item.label, deviceKey, 'data-device-value', state.device === deviceKey, item.icon, item.helper);
    });
    deviceOptions.innerHTML = html;
  }

  function renderBrands() {
    if (!brandOptions) return;

    var brandCards = [
      {
        key: 'apple',
        label: 'Apple',
        iconMarkup: getAppleBrandIcon(),
        helper: 'Sell an iPhone'
      },
      {
        key: 'samsung',
        label: 'Samsung',
        iconMarkup: getSamsungBrandIcon(),
        helper: 'Sell a Samsung phone'
      },
      {
        key: 'other',
        label: 'Other',
        iconMarkup: '<span class="sell-device__brand-other-icon">+</span>',
        helper: 'Enter another mobile manually'
      }
    ];

    brandOptions.innerHTML = brandCards.map(function (brand) {
      return '' +
        '<button type="button" class="sell-device__option sell-device__brand-card' +
          (state.brand === brand.key ? ' is-active' : '') +
          '" data-brand-value="' + escapeHtml(brand.key) + '">' +
          '<span class="sell-device__option-inner">' +
            '<span class="sell-device__option-icon sell-device__brand-icon">' +
              brand.iconMarkup +
            '</span>' +
            '<span>' +
              '<span class="sell-device__option-title">' + escapeHtml(brand.label) + '</span>' +
              '<span class="sell-device__option-helper">' + escapeHtml(brand.helper) + '</span>' +
            '</span>' +
          '</span>' +
        '</button>';
    }).join('');
  }

  function getAppleBrandIcon() {
    return '' +
      '<svg viewBox="0 0 384 512" aria-hidden="true" focusable="false">' +
        '<path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.3-2.8-73.9 20.6-88 20.6-14.9 0-49-19.7-72-19.7-37.3.6-71.7 21.7-91 55.2-39.1 67.8-9.9 167.4 28.1 222.6 18.9 27.3 41.6 58 71.4 56.9 28.5-1.1 39.2-18.4 73.4-18.4 34.2 0 44.1 18.4 74.1 17.8 30.6-.5 49.9-27.8 68.6-55.2 21.6-31.4 30.5-62.2 31-63.8-.7-.3-59.8-22.9-60-90.9zM259.6 104.5c15.7-18.5 26.3-44.3 23.5-70-22.7.9-50.2 16-66.2 34.6-14.4 16.2-27 42.4-23.7 67.2 25.3 2 50.7-11.4 66.4-31.8z"></path>' +
      '</svg>';
  }

  function getSamsungBrandIcon() {
    return '' +
      '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
        '<ellipse cx="32" cy="32" rx="28" ry="18" transform="rotate(-12 32 32)"></ellipse>' +
        '<text x="32" y="37" text-anchor="middle">S</text>' +
      '</svg>';
  }

  function renderSeriesChips() {
    if (!seriesChips || !seriesWrap) return;

    if (!state.brand || state.brand === 'other') {
      seriesWrap.hidden = true;
      seriesChips.innerHTML = '';
      return;
    }

    var models = getCurrentModels();
    var uniqueSeries = [];

    models.forEach(function (model) {
      if (!isAllowedSeriesForBrand(model.series, state.brand)) return;
      if (model.series && uniqueSeries.indexOf(model.series) === -1) uniqueSeries.push(model.series);
    });

    var preferredSeries = getPreferredSeriesForBrand(state.brand);
    uniqueSeries.sort(function (a, b) {
      var aIndex = preferredSeries.indexOf(a);
      var bIndex = preferredSeries.indexOf(b);

      if (aIndex !== -1 || bIndex !== -1) {
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      }

      return compareSeriesLabels(a, b);
    });
    seriesWrap.hidden = !uniqueSeries.length;

    seriesChips.innerHTML = uniqueSeries.map(function (series) {
      return '<button type="button" class="sell-device__chip' + (state.seriesFilter === series ? ' is-active' : '') + '" data-series-value="' + escapeHtml(series) + '">' + escapeHtml(series) + '</button>';
    }).join('');
  }
  function renderModels() {
    if (!modelGrid) return;

    if (state.brand === 'other') {
      modelGrid.innerHTML = '';
      if (modelSection) modelSection.hidden = true;
      return;
    }

    if (!state.seriesFilter) {
      modelGrid.innerHTML = '';
      if (modelSection) modelSection.hidden = true;
      return;
    }

    var models = getFilteredModels();
    if (modelSection) modelSection.hidden = false;

    if (!models.length) {
      modelGrid.innerHTML = '<div class="sell-device__empty">No mobile models found for this series.</div>';
      return;
    }

    modelGrid.innerHTML = models.map(function (model) {
      return '<button type="button" class="sell-device__detail-btn' + (state.modelKey === model.key ? ' is-active' : '') + '" data-model-key="' + escapeHtml(model.key) + '" data-model-title="' + escapeHtml(model.title) + '">' + escapeHtml(model.title) + '</button>';
    }).join('');
  }
  function renderVariants() {
    if (!variantGrid) return;

    var model = state.brand === 'other' ? null : getCurrentModel();
    if (detailPanel) detailPanel.hidden = !model;

    if (!model) {
      variantGrid.innerHTML = '';
      if (selectedModelTitle) selectedModelTitle.textContent = 'Select a model';
      if (selectedModelHelper) selectedModelHelper.textContent = 'Choose the exact model above to continue.';
      setThumbContent(variantThumb, null);
      return;
    }

    if (selectedModelTitle) selectedModelTitle.textContent = model.title;
    if (selectedModelHelper) selectedModelHelper.textContent = model.series || 'Complete the details below';
    setThumbContent(variantThumb, model);

    var html = '';
    model.variants.forEach(function (variant) {
      html += '<button type="button" class="sell-device__variant-btn' + (state.variantKey === variant.key ? ' is-active' : '') + '" data-variant-key="' + escapeHtml(variant.key) + '" data-variant-label="' + escapeHtml(variant.label) + '">' + escapeHtml(variant.label) + '</button>';
    });

    variantGrid.innerHTML = html || '<div class="sell-device__empty">No memory options found.</div>';
  }

  function renderColors() {
    if (!colorGrid) return;

    var model = getCurrentModel();
    if (!model) {
      colorGrid.innerHTML = '';
      if (customColorWrap) customColorWrap.hidden = true;
      return;
    }

    var colors = Array.isArray(model.colors) && model.colors.length
      ? model.colors.slice()
      : getFallbackColors();

    if (colors.indexOf('Other') === -1) {
      colors.push('Other');
    }

    colorGrid.innerHTML =
      '<select class="sell-device__detail-select" data-color-select aria-label="Select device color">' +
        '<option value="">Select color</option>' +
        colors.map(function (color) {
          return '<option value="' + escapeHtml(color) + '"' +
            (state.color === color ? ' selected' : '') +
            '>' + escapeHtml(color) + '</option>';
        }).join('') +
      '</select>';

    if (customColorWrap) {
      customColorWrap.hidden = state.color !== 'Other';
    }

    if (customColorInput && customColorInput.value !== state.customColor) {
      customColorInput.value = state.customColor || '';
    }
  }

  function renderConditions() {
    if (!conditionGrid) return;

    if (!getCurrentModel()) {
      conditionGrid.innerHTML = '';
      return;
    }

    var conditions = ['Like New', 'Good', 'Fair', 'Damaged'];

    conditionGrid.innerHTML =
      '<select class="sell-device__detail-select" data-condition-select aria-label="Select device condition">' +
        '<option value="">Select condition</option>' +
        conditions.map(function (condition) {
          return '<option value="' + escapeHtml(condition) + '"' +
            (state.condition === condition ? ' selected' : '') +
            '>' + escapeHtml(condition) + '</option>';
        }).join('') +
      '</select>';
  }

  function renderBatteryHealth() {
    if (!batteryGrid || !batteryWrap) return;

    var requiresBattery = requiresBatteryHealth();
    batteryWrap.hidden = !requiresBattery;

    if (!requiresBattery || !getCurrentModel()) {
      batteryGrid.innerHTML = '';
      if (!requiresBattery) state.batteryHealth = '';
      return;
    }

    var options = ['90% or above', '85%–89%', '80%–84%', 'Below 80%', 'Not sure'];

    batteryGrid.innerHTML =
      '<select class="sell-device__detail-select" data-battery-select aria-label="Select battery health">' +
        '<option value="">Select battery health</option>' +
        options.map(function (option) {
          return '<option value="' + escapeHtml(option) + '"' +
            (state.batteryHealth === option ? ' selected' : '') +
            '>' + escapeHtml(option) + '</option>';
        }).join('') +
      '</select>';
  }

  function updateBrandDetailMode() {
    var isOther = state.brand === 'other';

    if (catalogDetails) catalogDetails.hidden = isOther || !state.brand;
    if (otherDetails) otherDetails.hidden = !isOther;

    if (isOther) {
      if (seriesWrap) seriesWrap.hidden = true;
      if (modelSection) modelSection.hidden = true;
      if (detailPanel) detailPanel.hidden = true;
    }
  }

  function renderOtherConditions() {
    if (!otherConditionGrid) return;

    var options = ['Like New', 'Good', 'Fair', 'Damaged'];

    otherConditionGrid.innerHTML =
      '<select class="sell-device__detail-select" data-other-condition-select aria-label="Select device condition">' +
        '<option value="">Select condition</option>' +
        options.map(function (option) {
          return '<option value="' + escapeHtml(option) + '"' +
            (state.otherCondition === option ? ' selected' : '') +
            '>' + escapeHtml(option) + '</option>';
        }).join('') +
      '</select>';
  }

  function renderOtherBatteryHealth() {
    if (!otherBatteryGrid) return;

    var options = ['90% or above', '85%–89%', '80%–84%', 'Below 80%', 'Not sure'];

    otherBatteryGrid.innerHTML =
      '<select class="sell-device__detail-select" data-other-battery-select aria-label="Select battery health">' +
        '<option value="">Select battery health</option>' +
        options.map(function (option) {
          return '<option value="' + escapeHtml(option) + '"' +
            (state.otherBatteryHealth === option ? ' selected' : '') +
            '>' + escapeHtml(option) + '</option>';
        }).join('') +
      '</select>';
  }

  function isOtherMobileComplete() {
    return !!(
      state.otherBrand &&
      state.otherModel &&
      state.otherMemory &&
      state.otherColor &&
      state.otherCondition &&
      state.otherBatteryHealth
    );
  }

  function getPreferredSeriesForBrand(brandKey) {
    if (brandKey === 'apple') {
      return [
        'iPhone 17 Series',
        'iPhone 16 Series',
        'iPhone 15 Series',
        'iPhone 14 Series',
        'iPhone 13 Series',
        'iPhone 12 Series',
        'iPhone 11 Series'
      ];
    }

    if (brandKey === 'samsung') {
      return [
        'Samsung Fold Series',
        'Samsung S26 Series',
        'Samsung S25 Series',
        'Samsung S24 Series',
        'Samsung S23 Series',
        'Samsung S22 Series',
        'Samsung S21 Series'
      ];
    }

    return [];
  }

  function isAllowedSeriesForBrand(series, brandKey) {
    return getPreferredSeriesForBrand(brandKey).indexOf(String(series || '')) !== -1;
  }

  function isAllowedModelForBrand(model, brandKey) {
    if (!model) return false;
    var haystack = [model.title, model.sourceTitle, model.series].join(' ');
    if (brandKey === 'apple') return /\biPhone\b/i.test(haystack) && isAllowedSeriesForBrand(model.series, brandKey);
    if (brandKey === 'samsung') return /\bSamsung\b|\bGalaxy\b/i.test(haystack) && isAllowedSeriesForBrand(model.series, brandKey);
    return false;
  }

  function updateContinueState() {
    if (!continueButton) return;
    continueButton.disabled = !isDeviceDetailsComplete();
  }

  function isDeviceDetailsComplete() {
    if (state.brand === 'other') return isOtherMobileComplete();

    return !!(
      state.brand &&
      state.seriesFilter &&
      getCurrentModel() &&
      getCurrentVariant() &&
      getSelectedColorLabel() &&
      state.condition &&
      state.batteryHealth
    );
  }
  function validateDeviceDetailsStep() {
    if (!state.brand) {
      showNotice('Please select a mobile brand first.');
      goToStep(1);
      return false;
    }

    if (state.brand === 'other') {
      if (!state.otherBrand || !state.otherModel || !state.otherMemory || !state.otherColor) {
        showNotice('Please enter the brand, model, memory and color.');
        goToStep(2);
        return false;
      }
      if (!state.otherCondition) {
        showNotice('Please select the device condition.');
        goToStep(2);
        return false;
      }
      if (!state.otherBatteryHealth) {
        showNotice('Please select the battery health.');
        goToStep(2);
        return false;
      }
      clearNotice();
      return true;
    }

    if (!state.seriesFilter) {
      showNotice('Please select a mobile series first.');
      goToStep(2);
      return false;
    }
    if (!getCurrentModel()) {
      showNotice('Please select the exact mobile model.');
      goToStep(2);
      return false;
    }
    if (!getCurrentVariant()) {
      showNotice('Please select the device memory.');
      goToStep(2);
      return false;
    }
    if (!state.color) {
      showNotice('Please select the device color.');
      goToStep(2);
      return false;
    }
    if (state.color === 'Other' && !state.customColor) {
      showNotice('Please enter the device color.');
      goToStep(2);

      if (customColorInput) {
        window.setTimeout(function () {
          customColorInput.focus();
        }, 30);
      }
      return false;
    }
    if (!state.condition) {
      showNotice('Please select the device condition.');
      goToStep(2);
      return false;
    }
    if (!state.batteryHealth) {
      showNotice('Please select the battery health.');
      goToStep(2);
      return false;
    }

    clearNotice();
    return true;
  }
  function requiresBatteryHealth() {
    return true;
  }
  function getSelectedColorLabel() {
    if (state.color === 'Other') {
      return String(state.customColor || '').trim();
    }

    return state.color || '';
  }

  function getFallbackColors() {
    return ['Black', 'White', 'Silver', 'Blue', 'Gold', 'Other'];
  }

  function resetDeviceDetailSelections(keepSeries) {
    if (!keepSeries) state.seriesFilter = '';
    state.modelKey = '';
    state.modelTitle = '';
    state.variantKey = '';
    state.variantLabel = '';
    state.color = '';
    state.customColor = '';
    if (customColorInput) customColorInput.value = '';
    state.condition = '';
    state.batteryHealth = '';
  }


  function updateSummary() {
    if (summaryProduct) summaryProduct.textContent = 'Mobile Phone';
    if (summaryBrand) summaryBrand.textContent = getBrandLabel() || '-';
    if (summarySeries) summarySeries.textContent = getSeriesLabel() || '-';

    if (state.brand === 'other') {
      if (summaryModel) summaryModel.textContent = state.otherModel || '-';
      if (summaryVariant) summaryVariant.textContent = state.otherMemory || '-';
      if (summaryColor) summaryColor.textContent = state.otherColor || '-';
      if (summaryCondition) summaryCondition.textContent = state.otherCondition || '-';
      if (summaryBattery) summaryBattery.textContent = state.otherBatteryHealth || '-';
    } else {
      var model = getCurrentModel();
      var variant = getCurrentVariant();
      if (summaryModel) summaryModel.textContent = model ? model.title : '-';
      if (summaryVariant) summaryVariant.textContent = variant ? variant.label : '-';
      if (summaryColor) summaryColor.textContent = getSelectedColorLabel() || '-';
      if (summaryCondition) summaryCondition.textContent = state.condition || '-';
      if (summaryBattery) summaryBattery.textContent = state.batteryHealth || '-';
    }

    updateNerdyPhotoSummary();
  }
  function updateSelectedPills() {
    if (!selectedPills) return;

    var pills = [];
    if (state.brand) pills.push(makePill('Brand', getBrandLabel()));

    if (state.brand === 'other') {
      if (state.otherModel) pills.push(makePill('Model', state.otherModel));
      if (state.otherMemory) pills.push(makePill('Memory', state.otherMemory));
    } else {
      if (getSeriesLabel()) pills.push(makePill('Series', getSeriesLabel()));
      var model = getCurrentModel();
      var variant = getCurrentVariant();
      if (model) pills.push(makePill('Model', model.title));
      if (variant) pills.push(makePill('Memory', variant.label));
    }

    selectedPills.innerHTML = pills.join('');
  }
  function initPhotoGuidePopup() {
    photoGuideCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closePhotoGuideModal(true);
      });
    });

    if (photoGuideDoneButton) {
      photoGuideDoneButton.disabled = false;
      photoGuideDoneButton.textContent = 'Choose photos';

      photoGuideDoneButton.addEventListener('click', function () {
        var photoInput =
          pendingPhotoInput ||
          (lastNerdyFields && lastNerdyFields.photos);

        if (!photoInput) {
          showPhotoSlotError(
            'The secure photo uploader is still loading. Please close this guide and try again.'
          );
          return;
        }

        clearPhotoSlotError();
        closePhotoGuideModal(false);
        allowNativePhotoPickerOnce = true;

        window.setTimeout(function () {
          photoInput.click();
        }, 30);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && photoGuideModal && !photoGuideModal.hidden) {
        closePhotoGuideModal(true);
      }
    });

    updateNativePhotoSelectionUi();
  }

  function prepareNerdyPhotoUploadField(photoInput) {
    if (!photoInput) return;

    var uploadWrapper = findNerdyFieldWrapper(photoInput);
    if (!uploadWrapper) uploadWrapper = photoInput.parentElement;
    if (!uploadWrapper) return;

    uploadWrapper.classList.remove('sell-device__nerdy-native-photo-field');
    uploadWrapper.classList.add('sell-device__nerdy-photo-field');
    uploadWrapper.removeAttribute('aria-hidden');

    photoInput.hidden = false;
    photoInput.removeAttribute('hidden');
    photoInput.removeAttribute('tabindex');
  }

  function bindPhotoGuideToInput(photoInput) {
    if (!photoInput || photoInput.getAttribute('data-photo-guide-bound') === 'true') return;

    photoInput.setAttribute('data-photo-guide-bound', 'true');
    photoInput.setAttribute('multiple', 'multiple');
    photoInput.setAttribute('accept', 'image/jpeg,image/png,image/webp,image/heic,image/heif');
    pendingPhotoInput = photoInput;

    var uploadWrapper = findNerdyFieldWrapper(photoInput);
    var clickTarget = uploadWrapper || photoInput;

    clickTarget.addEventListener('click', function (event) {
      if (allowNativePhotoPickerOnce) {
        allowNativePhotoPickerOnce = false;
        return;
      }

      var target = event.target;

      // Nerdy renders an individual remove control beside every uploaded
      // filename. Never prevent that native click; otherwise the × appears
      // unresponsive and the customer cannot replace selected photos.
      if (isNerdyPhotoRemoveControl(target, uploadWrapper)) {
        scheduleNativePhotoCountRefresh(photoInput);
        return;
      }

      if (
        target &&
        target.closest &&
        target.closest('[data-photo-guide-close], [data-photo-guide-done]')
      ) {
        return;
      }

      // Do not hijack ordinary clicks on an existing filename row.
      // Only the actual upload trigger should open the photo guide.
      if (!isNerdyPhotoUploadTrigger(target, photoInput, uploadWrapper)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      openPhotoGuideModal(photoInput);
    }, true);

    photoInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      if (allowNativePhotoPickerOnce) {
        allowNativePhotoPickerOnce = false;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      openPhotoGuideModal(photoInput);
    }, true);

    photoInput.addEventListener('change', function () {
      [30, 180, 450, 850].forEach(function (delay) {
        window.setTimeout(function () {
          refreshNativePhotoCount(photoInput, true);
          clearNerdyPhotoValidationState(photoInput);
        }, delay);
      });
    });

    if (nativePhotoObserver) {
      nativePhotoObserver.disconnect();
    }

    if (uploadWrapper) {
      nativePhotoObserver = new MutationObserver(function () {
        refreshNativePhotoCount(photoInput, false);
      });

      nativePhotoObserver.observe(uploadWrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    refreshNativePhotoCount(photoInput, false);
  }

  function isNerdyPhotoRemoveControl(target, uploadWrapper) {
    if (!target || !target.closest) return false;

    var control = target.closest(
      'button, a, [role="button"], [title], [aria-label], ' +
      '[class*="remove"], [class*="delete"], [class*="trash"], ' +
      '[data-action], svg'
    );

    if (!control) control = target;
    if (uploadWrapper && control !== uploadWrapper && !uploadWrapper.contains(control)) {
      return false;
    }

    var identity = normalizeNerdyText([
      control.getAttribute && control.getAttribute('title'),
      control.getAttribute && control.getAttribute('aria-label'),
      control.getAttribute && control.getAttribute('data-action'),
      control.getAttribute && control.getAttribute('class'),
      control.getAttribute && control.getAttribute('id'),
      control.textContent
    ].filter(Boolean).join(' '));

    var rawText = String(control.textContent || '').trim();

    return (
      identity.indexOf('remove') !== -1 ||
      identity.indexOf('delete') !== -1 ||
      identity.indexOf('trash') !== -1 ||
      identity.indexOf('clear file') !== -1 ||
      /^(x|×|✕|✖|❌)$/i.test(rawText)
    );
  }

  function isNerdyPhotoUploadTrigger(target, photoInput, uploadWrapper) {
    if (!target) return false;
    if (target === photoInput) return true;

    if (target.closest) {
      var label = photoInput && photoInput.id
        ? target.closest('label[for="' + cssEscapeValue(photoInput.id) + '"]')
        : null;

      if (label) return true;

      var interactive = target.closest(
        'label, button, [role="button"], input[type="file"], ' +
        '[class*="upload"], [class*="choose"], [class*="browse"]'
      );

      if (interactive) {
        var identity = normalizeNerdyText([
          interactive.getAttribute && interactive.getAttribute('title'),
          interactive.getAttribute && interactive.getAttribute('aria-label'),
          interactive.getAttribute && interactive.getAttribute('class'),
          interactive.textContent
        ].filter(Boolean).join(' '));

        if (
          identity.indexOf('device photos') !== -1 ||
          identity.indexOf('upload') !== -1 ||
          identity.indexOf('choose file') !== -1 ||
          identity.indexOf('browse') !== -1 ||
          identity.indexOf('add file') !== -1
        ) {
          return true;
        }
      }
    }

    // Some app themes use the file input as a transparent overlay. A direct
    // click inside an empty upload wrapper should still open the guide.
    if (
      uploadWrapper &&
      nativePhotoSelectedCount === 0 &&
      uploadWrapper.contains(target)
    ) {
      return true;
    }

    return false;
  }

  function cssEscapeValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value || ''));
    }

    return String(value || '').replace(/["\\]/g, '\\$&');
  }

  function scheduleNativePhotoCountRefresh(photoInput) {
    [40, 180, 500, 900].forEach(function (delay) {
      window.setTimeout(function () {
        refreshNativePhotoCount(photoInput, false);
        clearNerdyPhotoValidationState(photoInput);
      }, delay);
    });
  }

  function openPhotoGuideModal(photoInput) {
    if (!photoGuideModal) return;

    pendingPhotoInput = photoInput || pendingPhotoInput || (lastNerdyFields && lastNerdyFields.photos);
    photoGuideLastFocused = document.activeElement;
    photoGuideModal.hidden = false;
    photoGuideModal.removeAttribute('hidden');
    document.body.classList.add('sell-device-photo-modal-open');

    var mainButton = photoGuideDoneButton;
    var closeButton = photoGuideModal.querySelector('.sell-device__photo-modal-close');
    if (mainButton) mainButton.focus();
    else if (closeButton) closeButton.focus();
  }

  function closePhotoGuideModal(restoreFocus) {
    if (!photoGuideModal) return;

    photoGuideModal.hidden = true;
    photoGuideModal.setAttribute('hidden', '');
    document.body.classList.remove('sell-device-photo-modal-open');

    if (restoreFocus && photoGuideLastFocused && typeof photoGuideLastFocused.focus === 'function') {
      photoGuideLastFocused.focus();
    }
  }

  function refreshNativePhotoCount(photoInput, showErrors) {
    var count = readNativeNerdyPhotoCount(photoInput);
    nativePhotoSelectedCount = count;

    if (showErrors) {
      if (count < requiredPhotoMinimum) {
        showPhotoSlotError('Please select at least one clear device photo.');
      } else if (count > maximumPhotoCount) {
        showPhotoSlotError(
          'Please select no more than ' + maximumPhotoCount + ' photos.'
        );
      } else {
        clearPhotoSlotError();
      }
    }

    updateNativePhotoSelectionUi();
  }

  function readNativeNerdyPhotoCount(photoInput) {
    var wrapper = photoInput ? findNerdyFieldWrapper(photoInput) : null;

    // The visible Nerdy list is the source of truth after individual
    // remove/add operations. Its count updates when a single × is clicked.
    if (wrapper) {
      var text = String(wrapper.textContent || '');
      var match = text.match(/\b(\d+)\s*files?\b/i);

      if (match) {
        return Number(match[1]) || 0;
      }

      // When the last file is removed, some versions remove the count label.
      // If no filename rows remain, treat the current count as zero.
      var visibleRemoveControls = Array.from(
        wrapper.querySelectorAll(
          'button, a, [role="button"], [class*="remove"], ' +
          '[class*="delete"], [class*="trash"]'
        )
      ).filter(function (candidate) {
        return isNerdyPhotoRemoveControl(candidate, wrapper);
      });

      if (!visibleRemoveControls.length && nativePhotoSelectedCount > 0) {
        var wrapperText = normalizeNerdyText(wrapper.textContent || '');
        if (
          wrapperText.indexOf('device photos') !== -1 &&
          !/\.(jpe?g|png|webp|heic|heif)\b/i.test(wrapperText)
        ) {
          return 0;
        }
      }
    }

    if (photoInput && photoInput.files) {
      return photoInput.files.length;
    }

    return nativePhotoSelectedCount;
  }

  function updateNativePhotoSelectionUi() {
    var count = nativePhotoSelectedCount;
    var hasMinimum = count >= requiredPhotoMinimum;
    var percentage = count
      ? Math.min(100, Math.round((count / minimumPhotoCount) * 100))
      : 0;

    if (photoOverallLabel) {
      if (!count) {
        photoOverallLabel.textContent = 'Upload at least 1 photo';
      } else if (count >= minimumPhotoCount) {
        photoOverallLabel.textContent =
          count + ' photos selected';
      } else {
        photoOverallLabel.textContent =
          count + ' photo' + (count === 1 ? '' : 's') +
          ' selected — 6 recommended';
      }
    }

    if (photoOverallBar) {
      photoOverallBar.style.width = percentage + '%';
    }

    if (photoOverallTrack) {
      photoOverallTrack.setAttribute('aria-valuemin', String(requiredPhotoMinimum));
      photoOverallTrack.setAttribute('aria-valuemax', String(minimumPhotoCount));
      photoOverallTrack.setAttribute(
        'aria-valuenow',
        String(Math.min(count, minimumPhotoCount))
      );
    }

    if (photoGuideDoneButton) {
      photoGuideDoneButton.disabled = false;
      photoGuideDoneButton.textContent = hasMinimum
        ? 'Change selected photos'
        : 'Choose photos';
    }

    updateNerdySubmitAvailability();
    updateNerdyPhotoSummary();
  }

  function handlePhotoSlotFile(index, file) {
    if (!file || index < 0 || index >= minimumPhotoCount) return;

    clearPhotoSlotError();

    var allowedTypes = [
      'image/jpeg',
      'image/png',
      'image/webp',
      'image/heic',
      'image/heif'
    ];
    var maxBytes = 3 * 1024 * 1024;

    if (allowedTypes.indexOf(String(file.type || '').toLowerCase()) === -1) {
      showPhotoSlotError('Please upload JPG, PNG, WebP or HEIC images only.');
      return;
    }

    if (file.size > maxBytes) {
      showPhotoSlotError(file.name + ' is larger than 3 MB. Please choose a smaller image.');
      return;
    }

    var duplicateIndex = photoSlotFiles.findIndex(function (existingFile, existingIndex) {
      if (!existingFile || existingIndex === index) return false;
      return (
        existingFile.name === file.name &&
        existingFile.size === file.size &&
        existingFile.lastModified === file.lastModified
      );
    });

    if (duplicateIndex !== -1) {
      showPhotoSlotError(
        'This image is already used for ' +
        getPhotoSlotLabel(duplicateIndex) +
        '. Please choose a different photo.'
      );
      return;
    }

    revokePhotoSlotPreview(index);
    photoSlotFiles[index] = file;
    photoSlotPreviewUrls[index] = URL.createObjectURL(file);

    if (areRequiredPhotoSlotsComplete()) {
      syncPhotoSlotsToNerdyInput();
    } else if (photoSlotsSynced) {
      clearNerdyPhotoInput();
    }

    updatePhotoSlotUi();
  }

  function clearPhotoSlot(index) {
    if (index < 0 || index >= minimumPhotoCount) return;

    revokePhotoSlotPreview(index);
    photoSlotFiles[index] = null;
    photoSlotPreviewUrls[index] = '';

    if (photoSlotsSynced) {
      clearNerdyPhotoInput();
    }

    updatePhotoSlotUi();
  }

  function revokePhotoSlotPreview(index) {
    if (photoSlotPreviewUrls[index]) {
      URL.revokeObjectURL(photoSlotPreviewUrls[index]);
    }
  }

  function syncPhotoSlotsToNerdyInput() {
    var nerdyPhotoInput = pendingPhotoInput || (lastNerdyFields && lastNerdyFields.photos);
    if (!nerdyPhotoInput || !areRequiredPhotoSlotsComplete() || photoSlotsSynced) return;

    try {
      // Nerdy Form appends files when change events are fired repeatedly.
      // Send the complete six-file set only once. Replacements/removals clear
      // the previous app state before this function is called again.
      var transfer = new DataTransfer();

      photoSlotFiles.slice(0, minimumPhotoCount).forEach(function (file) {
        if (file) transfer.items.add(file);
      });

      nerdyPhotoInput.files = transfer.files;
      nerdyPhotoInput.dispatchEvent(new Event('change', { bubbles: true }));
      photoSlotsSynced = true;

      updateNerdyPhotoSummary(nerdyPhotoInput);
      clearPhotoSlotError();

      window.setTimeout(function () {
        clearNerdyPhotoValidationState(nerdyPhotoInput);
      }, 80);

      window.setTimeout(function () {
        clearNerdyPhotoValidationState(nerdyPhotoInput);
      }, 450);
    } catch (error) {
      photoSlotsSynced = false;
      console.error('Could not synchronize device photos with Nerdy Form.', error);
      showPhotoSlotError(
        'The browser could not prepare these photos for submission. Please refresh the page and try again.'
      );
    }
  }

  function clearNerdyPhotoInput(photoInput, notifyApp) {
    var nerdyPhotoInput = photoInput || pendingPhotoInput || (lastNerdyFields && lastNerdyFields.photos);
    if (!nerdyPhotoInput) return;

    try {
      var emptyTransfer = new DataTransfer();
      nerdyPhotoInput.files = emptyTransfer.files;

      // Dispatch one empty change when replacing/removing an already-synced set,
      // so Nerdy clears its internal attachment list before the next final sync.
      if (notifyApp !== false) {
        nerdyPhotoInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      photoSlotsSynced = false;
      updateNerdyPhotoSummary(nerdyPhotoInput);
    } catch (error) {
      console.error('Could not clear Nerdy Form photo attachments.', error);
    }
  }

  function clearNerdyPhotoValidationState(photoInput) {
    if (!photoInput) return;

    if (typeof photoInput.setCustomValidity === 'function') {
      photoInput.setCustomValidity('');
    }

    photoInput.removeAttribute('aria-invalid');
    photoInput.classList.remove('invalid', 'is-invalid', 'has-error');

    var wrapper = findNerdyFieldWrapper(photoInput);
    if (!wrapper) return;

    wrapper.classList.remove('invalid', 'is-invalid', 'has-error', 'error');

    Array.from(
      wrapper.querySelectorAll(
        '[role="alert"], [class*="error"], [class*="invalid"], small, .help-block'
      )
    ).forEach(function (candidate) {
      var text = normalizeNerdyText(candidate.textContent || '');

      if (
        text.indexOf('not more than') !== -1 &&
        text.indexOf('files') !== -1
      ) {
        candidate.hidden = true;
        candidate.style.display = 'none';
        candidate.textContent = '';
      }
    });
  }

  function importExistingNerdyPhotos(photoInput) {
    if (!photoInput || !photoInput.files || !photoInput.files.length) return;
    if (photoSlotFiles.some(Boolean)) return;

    Array.from(photoInput.files)
      .slice(0, minimumPhotoCount)
      .forEach(function (file, index) {
        photoSlotFiles[index] = file;
        photoSlotPreviewUrls[index] = URL.createObjectURL(file);
      });

    photoSlotsSynced = getCompletedPhotoSlotCount() >= minimumPhotoCount;
  }

  function updatePhotoSlotUi() {
    var completedCount = getCompletedPhotoSlotCount();

    photoSlotFiles.forEach(function (file, index) {
      var card = root.querySelector('[data-photo-slot-card="' + index + '"]');
      var button = root.querySelector('[data-photo-slot-button="' + index + '"]');
      var removeButton = root.querySelector('[data-photo-slot-remove="' + index + '"]');
      var stateLabel = root.querySelector('[data-photo-slot-state="' + index + '"]');
      var visual = card ? card.querySelector('[data-photo-slot-visual]') : null;

      if (!card || !button || !stateLabel) return;

      card.classList.toggle('is-complete', !!file);
      button.textContent = file ? 'Change photo' : 'Upload photo';
      stateLabel.textContent = file ? '✓ Photo uploaded' : 'Required';
      stateLabel.title = file ? file.name : '';
      stateLabel.classList.toggle('is-uploaded', !!file);

      if (removeButton) removeButton.hidden = !file;

      if (visual) {
        var preview = visual.querySelector('[data-photo-slot-preview]');

        if (file && photoSlotPreviewUrls[index]) {
          if (!preview) {
            preview = document.createElement('img');
            preview.className = 'sell-device__photo-slot-preview';
            preview.setAttribute('data-photo-slot-preview', '');
            preview.alt = getPhotoSlotLabel(index) + ' selected image';
            visual.appendChild(preview);
          }

          preview.src = photoSlotPreviewUrls[index];

          Array.from(visual.children).forEach(function (child) {
            if (child !== preview) child.hidden = true;
          });
        } else {
          if (preview) preview.remove();

          Array.from(visual.children).forEach(function (child) {
            child.hidden = false;
          });
        }
      }
    });

    var percentage = Math.round((completedCount / minimumPhotoCount) * 100);

    if (photoOverallLabel) {
      photoOverallLabel.textContent =
        completedCount + ' of ' + minimumPhotoCount + ' required photos complete';
    }

    if (photoOverallBar) {
      photoOverallBar.style.width = percentage + '%';
    }

    if (photoOverallTrack) {
      photoOverallTrack.setAttribute('aria-valuenow', String(completedCount));
    }

    if (photoGuideDoneButton) {
      photoGuideDoneButton.disabled = completedCount < minimumPhotoCount;
      photoGuideDoneButton.textContent =
        completedCount < minimumPhotoCount
          ? 'Complete all ' + minimumPhotoCount + ' photos'
          : 'Done — continue to form';
    }

    updateNerdySubmitAvailability();
    updateNerdyPhotoSummary(pendingPhotoInput || (lastNerdyFields && lastNerdyFields.photos));
  }

  function getCompletedPhotoSlotCount() {
    return photoSlotFiles.filter(Boolean).length;
  }

  function areRequiredPhotoSlotsComplete() {
    return getCompletedPhotoSlotCount() >= minimumPhotoCount;
  }

  function getFirstIncompletePhotoButton() {
    var firstMissingIndex = photoSlotFiles.findIndex(function (file) {
      return !file;
    });

    return firstMissingIndex === -1
      ? null
      : root.querySelector('[data-photo-slot-button="' + firstMissingIndex + '"]');
  }

  function getPhotoSlotLabel(index) {
    var card = root.querySelector('[data-photo-slot-card="' + index + '"]');
    return card ? card.getAttribute('data-photo-slot-label') || ('Photo ' + (index + 1)) : ('Photo ' + (index + 1));
  }

  function truncateFileName(name) {
    var text = String(name || '');
    return text.length > 32 ? text.slice(0, 29) + '…' : text;
  }

  function showPhotoSlotError(message) {
    if (!photoSlotError) return;
    photoSlotError.textContent = message;
    photoSlotError.hidden = false;
  }

  function clearPhotoSlotError() {
    if (!photoSlotError) return;
    photoSlotError.textContent = '';
    photoSlotError.hidden = true;
  }

  function findFirstNerdySubmitControl() {
    var searchRoots = getNerdySearchRoots();

    for (var rootIndex = 0; rootIndex < searchRoots.length; rootIndex += 1) {
      var controls = Array.from(
        searchRoots[rootIndex].querySelectorAll(
          'button, input[type="submit"], input[type="button"]'
        )
      );

      for (var controlIndex = 0; controlIndex < controls.length; controlIndex += 1) {
        if (getNerdySubmitControl(controls[controlIndex])) {
          return controls[controlIndex];
        }
      }
    }

    return null;
  }

  function updateNerdySubmitAvailability() {
    var searchRoots = getNerdySearchRoots();

    searchRoots.forEach(function (searchRoot) {
      var controls = Array.from(
        searchRoot.querySelectorAll(
          'button, input[type="submit"], input[type="button"]'
        )
      );

      controls.forEach(function (control) {
        if (!getNerdySubmitControl(control)) return;

        control.disabled = false;
        control.setAttribute('aria-disabled', 'false');
        control.classList.remove('sell-device__nerdy-submit-locked');
        control.removeAttribute('title');
      });
    });
  }

  function initNerdyIntegration() {
    if (!nerdyHost) return;

    bindNerdyRoot(nerdyHost);
    hideStaleNerdySuccessUi();
    tryConnectNerdyForm(true);

    // Observe only DOM additions/removals inside the Nerdy host while the app loads.
    // Attribute changes and the whole document are intentionally not observed,
    // because those generated repeated full-form scans while visitors typed.
    nerdyObserver = new MutationObserver(function () {
      if (nerdyConnectQueued || nerdyConnected) return;

      nerdyConnectQueued = true;
      window.requestAnimationFrame(function () {
        nerdyConnectQueued = false;
        tryConnectNerdyForm(true);
      });
    });

    nerdyObserver.observe(nerdyHost, {
      childList: true,
      subtree: true
    });

    window.addEventListener('message', handleNerdyWindowMessage);

    // Short startup-only fallback for slower app rendering.
    var attempts = 0;
    nerdyPollTimer = window.setInterval(function () {
      attempts += 1;
      tryConnectNerdyForm(true);

      if (nerdyConnected || attempts >= 30) {
        window.clearInterval(nerdyPollTimer);
        nerdyPollTimer = null;

        if (nerdyConnected && nerdyObserver) {
          nerdyObserver.disconnect();
          nerdyObserver = null;
        }
      }
    }, 400);
  }

  function prepareNerdyForm() {
    tryConnectNerdyForm(true);
    syncNerdyDeviceDetails();
    updateNerdyPhotoSummary();

    if (lastNerdyFields && lastNerdyFields.photos) {
      prepareNerdyPhotoUploadField(lastNerdyFields.photos);
      bindPhotoGuideToInput(lastNerdyFields.photos);
    }
  }

  function tryConnectNerdyForm(forceRefresh) {
    if (!nerdyHost || successShown) return;

    if (
      !forceRefresh &&
      nerdyConnected &&
      lastNerdyFields &&
      areNerdyFieldsConnected(lastNerdyFields)
    ) {
      return;
    }

    var searchRoots = getNerdySearchRoots();
    var connected = false;

    searchRoots.forEach(function (searchRoot) {
      bindNerdyRoot(searchRoot);

      var fields = resolveNerdyFields(searchRoot);
      if (!fields.hasAnyField) return;

      connected = true;
      lastNerdyFields = fields;
      cleanNerdyPresentation(searchRoot, fields);
      syncNerdyDeviceDetails(fields);
      bindPhoneField(fields.phone);
      bindRequiredNerdyFields(fields);
      if (fields.photos) {
        fields.photos.setAttribute(
          'aria-label',
          'Upload at least ' + minimumPhotoCount + ' device assessment photos'
        );
        fields.photos.setAttribute(
          'title',
          'Required: About Phone, battery health, front, back, left side and right side'
        );
        fields.photos.classList.add('sell-device__nerdy-photo-input');
        prepareNerdyPhotoUploadField(fields.photos);
        bindPhotoGuideToInput(fields.photos);
      }

      refreshNativePhotoCount(fields.photos, false);
      updateNerdyPhotoSummary(fields.photos);
      updateNerdySubmitAvailability();
    });

    if (connected) {
      nerdyConnected = true;
      nerdyHost.classList.add('is-ready');
      if (nerdyLoading) nerdyLoading.hidden = true;

      if (nerdyObserver) {
        nerdyObserver.disconnect();
        nerdyObserver = null;
      }
    }
  }

  function areNerdyFieldsConnected(fields) {
    if (!fields) return false;

    var controls = [
      fields.name,
      fields.email,
      fields.phone,
      fields.city,
      fields.area,
      fields.notes,
      fields.deviceDetails,
      fields.photos
    ].filter(Boolean);

    if (!controls.length) return false;

    return controls.some(function (control) {
      var ownerDocument = control.ownerDocument || document;
      return ownerDocument.documentElement && ownerDocument.documentElement.contains(control);
    });
  }

  function getNerdySearchRoots() {
    var roots = [nerdyHost];
    var iframes = Array.from(nerdyHost.querySelectorAll('iframe'));

    iframes.forEach(function (iframe) {
      try {
        var iframeDocument = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        if (iframeDocument && iframeDocument.documentElement) {
          roots.push(iframeDocument);
        }
      } catch (error) {
        // Cross-origin iframes cannot be accessed. The visible form will still work,
        // but automatic Device Details prefilling requires the app to render in-page.
      }
    });

    return roots;
  }

  function bindNerdyRoot(searchRoot) {
    if (!searchRoot || boundNerdyRoots.indexOf(searchRoot) !== -1) return;
    boundNerdyRoots.push(searchRoot);

    searchRoot.addEventListener('submit', function (event) {
      if (!validateNerdySubmission(event, searchRoot)) {
        nerdySubmissionPending = false;
        return;
      }

      armNerdySuccessDetection(searchRoot);
      state.submittedAt = new Date().toISOString();
      syncNerdyDeviceDetails(lastNerdyFields || resolveNerdyFields(searchRoot));
    }, true);

    searchRoot.addEventListener('click', function (event) {
      var submitControl = getNerdySubmitControl(event.target);
      if (!submitControl) return;

      if (!validateNerdySubmission(event, searchRoot)) {
        nerdySubmissionPending = false;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      armNerdySuccessDetection(searchRoot);
      state.submittedAt = new Date().toISOString();
      syncNerdyDeviceDetails(lastNerdyFields || resolveNerdyFields(searchRoot));
    }, true);

    searchRoot.addEventListener('input', function (event) {
      var fields = lastNerdyFields;

      if (fields && fields.phone && event.target === fields.phone) {
        clearNerdyPhoneError(fields.phone);
      }

      if (event.target && String(event.target.type || '').toLowerCase() === 'file') {
        updateNerdyPhotoSummary(event.target);
      }
    });

    searchRoot.addEventListener('change', function (event) {
      if (event.target && String(event.target.type || '').toLowerCase() === 'file') {
        updateNerdyPhotoSummary(event.target);
      }
    });

    searchRoot.addEventListener('blur', function (event) {
      var phoneField = lastNerdyFields && lastNerdyFields.phone;

      if (!phoneField || event.target !== phoneField) {
        var targetType = String(event.target && event.target.type || '').toLowerCase();
        var targetText = normalizeNerdyText([
          event.target && event.target.name,
          event.target && event.target.id,
          event.target && event.target.placeholder,
          event.target && event.target.getAttribute && event.target.getAttribute('aria-label')
        ].filter(Boolean).join(' '));

        if (targetType !== 'tel' && targetText.indexOf('phone') === -1 && targetText.indexOf('mobile') === -1) {
          return;
        }

        phoneField = event.target;
        if (lastNerdyFields) lastNerdyFields.phone = phoneField;
      }

      var normalizedPhone = normalizeUaeMobile(phoneField.value);
      if (normalizedPhone) {
        setNativeControlValue(phoneField, formatUaeMobile(normalizedPhone), false);
      }
      validateNerdyPhone(phoneField, true);
    }, true);
  }

  function getNerdySubmitControl(target) {
    if (!target || !target.closest) return null;

    var control = target.closest('button, input[type="submit"], input[type="button"]');
    if (!control) return null;

    var type = String(control.getAttribute('type') || '').toLowerCase();
    var text = normalizeNerdyText(control.value || control.textContent || '');

    if (type === 'submit' || /\bsubmit\b/.test(text)) return control;
    return null;
  }

  function validateNerdySubmission(event, searchRoot) {
    updateNerdySubmitAvailability();

    if (!getProductLabel() || !getBrandLabel() || !isDeviceDetailsComplete()) {
      stopNerdySubmission(event);
      showNotice('Please complete the device selection and device details first.');
      goToStep(2);
      return false;
    }

    var fields = resolveNerdyFields(searchRoot);
    fields.phone = findBestNerdyPhoneField(searchRoot, fields.phone);

    if (lastNerdyFields) {
      lastNerdyFields = Object.assign({}, lastNerdyFields, fields);
    }

    syncNerdyDeviceDetails(fields);
    clearRequiredNerdyFieldErrors(fields);

    if (!hasNerdyFieldValue(fields.name)) {
      return failRequiredNerdyField(
        event,
        fields.name,
        'Please enter your name.',
        'Please enter your name before submitting.'
      );
    }

    if (!hasNerdyFieldValue(fields.email)) {
      return failRequiredNerdyField(
        event,
        fields.email,
        'Please enter your email address.',
        'Please enter your email address before submitting.'
      );
    }

    if (!isValidNerdyEmail(fields.email.value)) {
      return failRequiredNerdyField(
        event,
        fields.email,
        'Please enter a valid email address.',
        'Please enter a valid email address before submitting.'
      );
    }

    if (!fields.phone || !validateNerdyPhone(fields.phone, true)) {
      stopNerdySubmission(event);
      showNotice('Please enter a valid UAE mobile number before submitting.');
      goToStep(3);

      if (fields.phone) {
        markNerdyFieldInvalid(fields.phone, 'Please enter a valid UAE mobile number.');
        focusNerdyRequiredField(fields.phone);
      }
      return false;
    }

    if (!hasNerdyFieldValue(fields.city)) {
      return failRequiredNerdyField(
        event,
        fields.city,
        'Please enter your city.',
        'Please enter your city before submitting.'
      );
    }

    refreshNativePhotoCount(fields.photos, false);

    if (nativePhotoSelectedCount < requiredPhotoMinimum) {
      stopNerdySubmission(event);
      showNotice('Please select at least one device photo before submitting.');
      goToStep(3);
      openPhotoGuideModal(fields.photos);
      return false;
    }

    if (nativePhotoSelectedCount > maximumPhotoCount) {
      stopNerdySubmission(event);
      showNotice(
        'Please select no more than ' + maximumPhotoCount +
        ' device photos before submitting.'
      );
      goToStep(3);
      openPhotoGuideModal(fields.photos);
      return false;
    }

    clearNerdyPhotoValidationState(fields.photos);

    var normalizedPhone = normalizeUaeMobile(fields.phone.value);
    if (normalizedPhone) {
      setNativeControlValue(
        fields.phone,
        formatUaeMobile(normalizedPhone),
        true
      );
      clearNerdyPhoneError(fields.phone);
    }

    clearRequiredNerdyFieldErrors(fields);
    clearNotice();
    return true;
  }

  function stopNerdySubmission(event) {
    if (!event) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function hasNerdyFieldValue(field) {
    return !!(field && String(field.value || '').trim());
  }

  function isValidNerdyEmail(value) {
    var email = String(value || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function failRequiredNerdyField(event, field, fieldMessage, noticeMessage) {
    stopNerdySubmission(event);
    goToStep(3);
    showNotice(noticeMessage);

    if (field) {
      markNerdyFieldInvalid(field, fieldMessage);
      focusNerdyRequiredField(field);
    }

    return false;
  }

  function markNerdyFieldInvalid(field, message) {
    if (!field) return;

    if (typeof field.setCustomValidity === 'function') {
      field.setCustomValidity(message || 'Please complete this field.');
    }

    field.setAttribute('aria-invalid', 'true');

    var wrapper = findNerdyFieldWrapper(field);
    if (wrapper) {
      wrapper.classList.add('is-invalid', 'has-error');
    }

    if (typeof field.reportValidity === 'function') {
      field.reportValidity();
    }
  }

  function clearNerdyRequiredFieldError(field) {
    if (!field) return;

    if (typeof field.setCustomValidity === 'function') {
      field.setCustomValidity('');
    }

    field.removeAttribute('aria-invalid');

    var wrapper = findNerdyFieldWrapper(field);
    if (wrapper) {
      wrapper.classList.remove('is-invalid', 'has-error', 'invalid', 'error');
    }
  }

  function clearRequiredNerdyFieldErrors(fields) {
    if (!fields) return;

    [
      fields.name,
      fields.email,
      fields.phone,
      fields.city
    ].filter(Boolean).forEach(clearNerdyRequiredFieldError);
  }

  function focusNerdyRequiredField(field) {
    if (!field) return;

    window.setTimeout(function () {
      field.focus();
      scrollNerdyFieldIntoView(field);

      if (typeof field.reportValidity === 'function') {
        field.reportValidity();
      }
    }, 20);
  }

  function bindRequiredNerdyFields(fields) {
    if (!fields) return;

    [
      fields.name,
      fields.email,
      fields.city
    ].filter(Boolean).forEach(function (field) {
      if (field.getAttribute('data-sell-device-required-bound') === 'true') return;

      field.setAttribute('data-sell-device-required-bound', 'true');

      field.addEventListener('input', function () {
        clearNerdyRequiredFieldError(field);
        clearNotice();
      });

      field.addEventListener('change', function () {
        clearNerdyRequiredFieldError(field);
      });
    });
  }

  function findBestNerdyPhoneField(searchRoot, preferredField) {
    var candidates = [];

    if (preferredField) candidates.push(preferredField);
    if (
      lastNerdyFields &&
      lastNerdyFields.phone &&
      candidates.indexOf(lastNerdyFields.phone) === -1
    ) {
      candidates.push(lastNerdyFields.phone);
    }

    if (searchRoot && searchRoot.querySelectorAll) {
      Array.from(
        searchRoot.querySelectorAll(
          'input[type="tel"], input[type="text"], input[type="number"]'
        )
      ).forEach(function (control) {
        var identity = normalizeNerdyText([
          control.name,
          control.id,
          control.placeholder,
          control.getAttribute('aria-label'),
          getNerdyLabelText(control)
        ].filter(Boolean).join(' '));

        if (
          control.type === 'tel' ||
          identity.indexOf('phone') !== -1 ||
          identity.indexOf('mobile') !== -1 ||
          identity.indexOf('enter your number') !== -1
        ) {
          if (candidates.indexOf(control) === -1) {
            candidates.push(control);
          }
        }
      });
    }

    var visibleCandidates = candidates.filter(function (control) {
      if (!control || control.disabled) return false;

      var type = String(control.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden') return false;

      var ownerWindow = control.ownerDocument && control.ownerDocument.defaultView
        ? control.ownerDocument.defaultView
        : window;
      var style = ownerWindow.getComputedStyle
        ? ownerWindow.getComputedStyle(control)
        : null;

      return !style || (
        style.display !== 'none' &&
        style.visibility !== 'hidden'
      );
    });

    var validFilled = visibleCandidates.find(function (control) {
      return !!normalizeUaeMobile(control.value);
    });
    if (validFilled) return validFilled;

    var filled = visibleCandidates.find(function (control) {
      return String(control.value || '').trim() !== '';
    });
    if (filled) return filled;

    return visibleCandidates[0] || preferredField || null;
  }

  function resolveNerdyFields(searchRoot) {
    var controls = Array.from(searchRoot.querySelectorAll('input, textarea, select')).filter(function (control) {
      var type = String(control.getAttribute('type') || '').toLowerCase();
      return type !== 'submit' && type !== 'button' && type !== 'reset';
    });

    var fields = {
      name: findNerdyControl(controls, ['name', 'enter your name'], ['text']),
      email: findNerdyControl(controls, ['email', 'enter your email'], ['email', 'text']),
      phone: findNerdyControl(controls, ['phone', 'mobile number', 'enter your number'], ['tel', 'text', 'number']),
      city: findNerdyControl(controls, ['city'], ['text']),
      area: findNerdyControl(controls, ['area district', 'area / district', 'enter your area district'], ['text']),
      notes: findNerdyControl(controls, ['additional details', 'extra details', 'any extra details'], ['textarea', 'text']),
      deviceDetails: findNerdyControl(controls, ['device details'], ['textarea', 'text', 'hidden']),
      photos: findNerdyControl(controls, ['device photos', 'file upload', 'upload files'], ['file'])
    };

    fields.hasAnyField = !!(
      fields.name ||
      fields.email ||
      fields.phone ||
      fields.city ||
      fields.area ||
      fields.notes ||
      fields.deviceDetails ||
      fields.photos
    );

    return fields;
  }

  function findNerdyControl(controls, terms, allowedTypes) {
    var bestControl = null;
    var bestScore = 0;

    controls.forEach(function (control) {
      var controlType = getNerdyControlType(control);
      if (allowedTypes && allowedTypes.length && allowedTypes.indexOf(controlType) === -1) return;

      var directText = normalizeNerdyText([
        control.getAttribute('name'),
        control.id,
        control.getAttribute('placeholder'),
        control.getAttribute('aria-label'),
        control.getAttribute('title'),
        control.getAttribute('data-label')
      ].filter(Boolean).join(' '));

      var labelText = normalizeNerdyText(getNerdyLabelText(control));
      var score = 0;

      terms.forEach(function (term) {
        var normalizedTerm = normalizeNerdyText(term);
        if (!normalizedTerm) return;

        if (labelText === normalizedTerm) score = Math.max(score, 120);
        else if (labelText.indexOf(normalizedTerm) !== -1) score = Math.max(score, 95);

        if (directText === normalizedTerm) score = Math.max(score, 110);
        else if (directText.indexOf(normalizedTerm) !== -1) score = Math.max(score, 85);
      });

      if (score > bestScore) {
        bestScore = score;
        bestControl = control;
      }
    });

    if (!bestControl && allowedTypes && allowedTypes.length) {
      var typeMatches = controls.filter(function (control) {
        return allowedTypes.indexOf(getNerdyControlType(control)) !== -1;
      });

      if (typeMatches.length === 1) {
        bestControl = typeMatches[0];
      }
    }

    return bestControl;
  }

  function getNerdyControlType(control) {
    var tagName = String(control.tagName || '').toLowerCase();
    if (tagName === 'textarea') return 'textarea';
    if (tagName === 'select') return 'select';
    return String(control.getAttribute('type') || 'text').toLowerCase();
  }

  function getNerdyLabelText(control) {
    var labels = [];

    if (control.labels && control.labels.length) {
      Array.from(control.labels).forEach(function (label) {
        labels.push(label.textContent || '');
      });
    }

    if (control.id) {
      var ownerDocument = control.ownerDocument || document;
      var explicitLabel = Array.from(ownerDocument.querySelectorAll('label')).find(function (label) {
        return label.htmlFor === control.id;
      });
      if (explicitLabel) labels.push(explicitLabel.textContent || '');
    }

    var closestLabel = control.closest ? control.closest('label') : null;
    if (closestLabel) labels.push(closestLabel.textContent || '');

    var wrapper = findNerdyFieldWrapper(control);
    if (wrapper) {
      var wrapperLabels = Array.from(wrapper.querySelectorAll('label, legend, [class*="label"]'));
      wrapperLabels.slice(0, 3).forEach(function (label) {
        labels.push(label.textContent || '');
      });
    }

    return labels.join(' ');
  }

  function findNerdyFieldWrapper(control) {
    if (!control) return null;

    var current = control.parentElement;
    var depth = 0;

    while (current && depth < 6) {
      var tagName = String(current.tagName || '').toLowerCase();
      if (tagName === 'form' || current === nerdyHost) break;

      var controls = current.querySelectorAll('input:not([type="hidden"]), textarea, select');
      var className = String(current.className || '').toLowerCase();
      var hasFieldClass = /field|element|form-group|input-group|control/.test(className);
      var hasLabel = !!current.querySelector('label, legend, [class*="label"]');

      if (controls.length === 1 && (hasFieldClass || hasLabel)) {
        return current;
      }

      current = current.parentElement;
      depth += 1;
    }

    return control.parentElement;
  }

  function cleanNerdyPresentation(searchRoot, fields) {
    if (fields.deviceDetails) {
      var deviceDetailsWrapper = findNerdyFieldWrapper(fields.deviceDetails);
      if (deviceDetailsWrapper) {
        deviceDetailsWrapper.classList.add('sell-device__nerdy-hidden-field');
        deviceDetailsWrapper.setAttribute('aria-hidden', 'true');
      } else {
        fields.deviceDetails.hidden = true;
      }
      fields.deviceDetails.tabIndex = -1;
    }

    Array.from(searchRoot.querySelectorAll('h1, h2, h3, h4')).forEach(function (heading) {
      var headingText = normalizeNerdyText(heading.textContent || '');
      if (headingText === 'sell device request') {
        heading.hidden = true;
      }
    });
  }

  function syncNerdyDeviceDetails(fields) {
    if (!nerdyHost) return;

    var resolvedFields = fields || lastNerdyFields;
    if (!resolvedFields || !resolvedFields.deviceDetails) {
      var searchRoots = getNerdySearchRoots();
      for (var i = 0; i < searchRoots.length; i++) {
        resolvedFields = resolveNerdyFields(searchRoots[i]);
        if (resolvedFields.deviceDetails) break;
      }
    }

    if (!resolvedFields || !resolvedFields.deviceDetails) return;

    var detailsValue = buildNerdyDeviceDetails();
    setNativeControlValue(resolvedFields.deviceDetails, detailsValue, true);
  }

  function buildNerdyDeviceDetails() {
    // Unicode bold labels are used because Nerdy's custom email placeholder
    // renders this hidden field as plain text rather than trusted HTML.
    var labels = {
      reference: '𝗦𝘂𝗯𝗺𝗶𝘀𝘀𝗶𝗼𝗻 𝗥𝗲𝗳𝗲𝗿𝗲𝗻𝗰𝗲:',
      product: '𝗣𝗿𝗼𝗱𝘂𝗰𝘁:',
      brand: '𝗕𝗿𝗮𝗻𝗱:',
      series: '𝗦𝗲𝗿𝗶𝗲𝘀:',
      model: '𝗠𝗼𝗱𝗲𝗹:',
      memory: '𝗠𝗲𝗺𝗼𝗿𝘆:',
      color: '𝗖𝗼𝗹𝗼𝗿:',
      condition: '𝗖𝗼𝗻𝗱𝗶𝘁𝗶𝗼𝗻:',
      battery: '𝗕𝗮𝘁𝘁𝗲𝗿𝘆 𝗛𝗲𝗮𝗹𝘁𝗵:'
    };

    var lines = [
      labels.reference + ' ' + state.submissionReference,
      labels.product + ' Mobile Phone',
      labels.brand + ' ' + (getBrandLabel() || '')
    ];

    if (state.brand === 'other') {
      lines.push(
        labels.series + ' Other / Not listed',
        labels.model + ' ' + (state.otherModel || ''),
        labels.memory + ' ' + (state.otherMemory || ''),
        labels.color + ' ' + (state.otherColor || ''),
        labels.condition + ' ' + (state.otherCondition || ''),
        labels.battery + ' ' + (state.otherBatteryHealth || '')
      );
    } else {
      var model = getCurrentModel();
      var variant = getCurrentVariant();
      lines.push(
        labels.series + ' ' + (getSeriesLabel() || ''),
        labels.model + ' ' + (model ? model.title : ''),
        labels.memory + ' ' + (variant ? variant.label : ''),
        labels.color + ' ' + (getSelectedColorLabel() || ''),
        labels.condition + ' ' + (state.condition || ''),
        labels.battery + ' ' + (state.batteryHealth || '')
      );
    }

    // Submitted date/time is already shown by the separate Nerdy Submit
    // placeholder in the custom email template, so it is not repeated here.
    return lines.join('\n');
  }
  function setNativeControlValue(control, value, dispatchEvents) {
    if (!control) return;

    var ownerWindow = control.ownerDocument && control.ownerDocument.defaultView
      ? control.ownerDocument.defaultView
      : window;
    var prototype;

    if (control.tagName === 'TEXTAREA') {
      prototype = ownerWindow.HTMLTextAreaElement && ownerWindow.HTMLTextAreaElement.prototype;
    } else if (control.tagName === 'SELECT') {
      prototype = ownerWindow.HTMLSelectElement && ownerWindow.HTMLSelectElement.prototype;
    } else {
      prototype = ownerWindow.HTMLInputElement && ownerWindow.HTMLInputElement.prototype;
    }

    var descriptor = prototype ? Object.getOwnPropertyDescriptor(prototype, 'value') : null;
    if (descriptor && descriptor.set) {
      descriptor.set.call(control, value);
    } else {
      control.value = value;
    }

    control.defaultValue = value;

    if (dispatchEvents) {
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function highlightPrimaryNameField(fields) {
    if (!fields || !fields.name) return;

    var nameField = fields.name;
    var phoneField = fields.phone;
    var nameWrapper = findNerdyFieldWrapper(nameField);

    if (nameWrapper) {
      nameWrapper.classList.add('sell-device__nerdy-name-primary');
    }

    nameField.classList.add('sell-device__nerdy-name-primary-input');

    if (phoneField) {
      phoneField.removeAttribute('autofocus');

      try {
        var ownerDocument = phoneField.ownerDocument || document;
        if (ownerDocument.activeElement === phoneField) {
          phoneField.blur();
        }
      } catch (error) {
        // Ignore browsers that do not allow programmatic blur here.
      }
    }

    updatePrimaryNameHighlight(nameField);

    if (
      !String(nameField.value || '').trim() &&
      root.getAttribute('data-name-initial-focus-done') !== 'true'
    ) {
      root.setAttribute('data-name-initial-focus-done', 'true');

      window.setTimeout(function () {
        try {
          nameField.focus({ preventScroll: true });
        } catch (error) {
          nameField.focus();
        }
      }, 140);
    }

    if (nameField.getAttribute('data-name-highlight-bound') !== 'true') {
      nameField.setAttribute('data-name-highlight-bound', 'true');

      ['input', 'change', 'blur'].forEach(function (eventName) {
        nameField.addEventListener(eventName, function () {
          updatePrimaryNameHighlight(nameField);
        });
      });
    }
  }

  function updatePrimaryNameHighlight(nameField) {
    if (!nameField) return;

    var empty = !String(nameField.value || '').trim();
    var wrapper = findNerdyFieldWrapper(nameField);

    nameField.classList.toggle('is-primary-empty', empty);
    root.classList.toggle('sell-device--name-pending', empty);

    if (wrapper) {
      wrapper.classList.toggle('is-primary-empty', empty);
    }
  }

  function bindPhoneField(phoneField) {
    if (!phoneField || phoneField.getAttribute('data-sell-device-phone-bound') === 'true') return;

    phoneField.setAttribute('data-sell-device-phone-bound', 'true');

    if (String(phoneField.tagName || '').toLowerCase() === 'input') {
      phoneField.setAttribute('type', 'tel');
    }

    phoneField.setAttribute('inputmode', 'tel');
    phoneField.setAttribute('autocomplete', 'tel');
    phoneField.setAttribute('maxlength', '20');

    var wrapper = findNerdyFieldWrapper(phoneField);
    if (wrapper) {
      wrapper.classList.add('sell-device__nerdy-phone-field');
    }

    phoneField.addEventListener('input', function () {
      clearNerdyPhoneError(phoneField);
    });

    phoneField.addEventListener('change', function () {
      clearNerdyPhoneError(phoneField);
    });

    phoneField.addEventListener('blur', function () {
      var normalizedPhone = normalizeUaeMobile(phoneField.value);

      if (normalizedPhone) {
        setNativeControlValue(
          phoneField,
          formatUaeMobile(normalizedPhone),
          true
        );
      }

      validateNerdyPhone(phoneField, true);
    });
  }

  function validateNerdyPhone(phoneField, showMessage) {
    if (!phoneField) return false;

    var value = String(phoneField.value || '').trim();
    var normalizedPhone = normalizeUaeMobile(value);
    var message = '';

    if (!value) {
      message = 'Please enter your mobile number.';
    } else if (!normalizedPhone) {
      message = 'Enter a valid UAE mobile number, such as 050 123 4567 or +971 50 123 4567.';
    }

    if (typeof phoneField.setCustomValidity === 'function') {
      phoneField.setCustomValidity(message);
    }

    phoneField.setAttribute('aria-invalid', message ? 'true' : 'false');
    phoneField.classList.toggle('sell-device__nerdy-invalid', !!message);

    var wrapper = findNerdyFieldWrapper(phoneField);
    if (wrapper) {
      wrapper.classList.add('sell-device__nerdy-phone-field');
      wrapper.classList.toggle('has-error', !!message);

      var existingError = wrapper.querySelector('[data-sell-device-nerdy-phone-error]');

      if (message && showMessage) {
        if (!existingError) {
          existingError = phoneField.ownerDocument.createElement('small');
          existingError.className = 'sell-device__nerdy-phone-error';
          existingError.setAttribute('data-sell-device-nerdy-phone-error', '');
          existingError.setAttribute('role', 'alert');
          existingError.setAttribute('aria-live', 'polite');
          phoneField.insertAdjacentElement('afterend', existingError);
        }
        existingError.textContent = message;
        existingError.hidden = false;
      } else if (existingError) {
        existingError.hidden = true;
        existingError.textContent = '';
      }
    }

    return !message;
  }

  function clearNerdyPhoneError(phoneField) {
    if (!phoneField) return;
    if (typeof phoneField.setCustomValidity === 'function') {
      phoneField.setCustomValidity('');
    }
    phoneField.removeAttribute('aria-invalid');
    phoneField.classList.remove('sell-device__nerdy-invalid');

    var wrapper = findNerdyFieldWrapper(phoneField);
    if (wrapper) {
      wrapper.classList.remove('has-error');
    }

    var existingError = wrapper ? wrapper.querySelector('[data-sell-device-nerdy-phone-error]') : null;
    if (existingError) {
      existingError.hidden = true;
      existingError.textContent = '';
    }
  }

  function scrollNerdyFieldIntoView(field) {
    if (!field || typeof field.getBoundingClientRect !== 'function') return;

    window.setTimeout(function () {
      var rect = field.getBoundingClientRect();
      var topOffset = rect.top + window.pageYOffset - 150;
      window.scrollTo({ top: Math.max(0, topOffset), behavior: 'smooth' });
    }, 30);
  }

  function normalizeUaeMobile(value) {
    var digits = String(value || '').replace(/\D/g, '');

    if (digits.indexOf('00971') === 0) {
      digits = digits.slice(2);
    }

    if (/^05\d{8}$/.test(digits)) {
      return '+971' + digits.slice(1);
    }

    if (/^5\d{8}$/.test(digits)) {
      return '+971' + digits;
    }

    if (/^9715\d{8}$/.test(digits)) {
      return '+' + digits;
    }

    return '';
  }

  function formatUaeMobile(normalizedPhone) {
    var match = String(normalizedPhone || '').match(/^\+971(5\d)(\d{3})(\d{4})$/);
    return match ? '+971 ' + match[1] + ' ' + match[2] + ' ' + match[3] : normalizedPhone;
  }

  function updateNerdyPhotoSummary(photoField) {
    if (!summaryPhotos) return;

    var count = nativePhotoSelectedCount;

    if (!count) {
      summaryPhotos.textContent = 'Minimum 1 required';
    } else {
      summaryPhotos.textContent =
        count + ' photo' + (count === 1 ? '' : 's') + ' selected';
    }
  }

  function armNerdySuccessDetection(searchRoot) {
    nerdySubmissionPending = true;
    nerdySubmissionStartedAt = Date.now();
    nerdyPreSubmitFieldCount = countNerdyFields(getNerdySearchRoots());

    clearNerdySuccessTimers();

    // A dedicated short poll makes detection reliable even when the app changes
    // the form without emitting a mutation that our host observer can see.
    nerdySuccessCheckTimer = window.setInterval(function () {
      detectNerdySuccess();
    }, 450);

    // Do not keep a failed or abandoned submission armed forever.
    nerdySuccessTimeoutTimer = window.setTimeout(function () {
      nerdySubmissionPending = false;
      nerdySubmissionStartedAt = 0;
      nerdyPreSubmitFieldCount = 0;
      clearNerdySuccessTimers();
    }, 90000);

    syncNerdyDeviceDetails(resolveNerdyFields(searchRoot));
  }

  function handleNerdyWindowMessage(event) {
    if (!nerdySubmissionPending || successShown) return;

    var messageText = '';
    try {
      messageText = typeof event.data === 'string'
        ? event.data
        : JSON.stringify(event.data || '');
    } catch (error) {
      messageText = '';
    }

    if (isNerdySuccessText(normalizeNerdyText(messageText))) {
      showNerdySuccess();
    }
  }

  function detectNerdySuccess() {
    if (!nerdyHost || successShown || !nerdySubmissionPending) return;

    var searchRoots = getNerdySuccessSearchRoots();
    var successCandidates = [];
    var successDetected = false;

    searchRoots.forEach(function (searchRoot) {
      if (successDetected) return;

      getNerdySuccessCandidates(searchRoot).some(function (candidate) {
        if (!candidate || candidate === nerdySuccess) return false;
        if (candidate.closest && candidate.closest('[data-nerdy-success]')) return false;
        if (!isElementVisible(candidate)) return false;

        var text = normalizeNerdyText(candidate.textContent || candidate.value || '');
        if (!isNerdySuccessText(text)) return false;

        successCandidates.push(candidate);
        successDetected = true;
        return true;
      });
    });

    // Fallback for app versions that replace the form with a success panel whose
    // wording is customized. We only accept this after a real submit action and
    // after all form fields disappear without a visible error state.
    if (!successDetected && nerdySubmissionStartedAt) {
      var elapsed = Date.now() - nerdySubmissionStartedAt;
      var currentFieldCount = countNerdyFields(getNerdySearchRoots());
      var visibleText = getVisibleNerdyHostText();

      if (
        elapsed >= 1800 &&
        nerdyPreSubmitFieldCount > 0 &&
        currentFieldCount === 0 &&
        visibleText &&
        !isNerdyErrorText(visibleText) &&
        !isNerdyLoadingText(visibleText)
      ) {
        successDetected = true;
      }
    }

    if (successDetected) {
      successCandidates.forEach(hideNerdyElement);
      hideNerdyDefaultSuccessUi();
      showNerdySuccess();
    }
  }

  function getNerdySuccessSearchRoots() {
    var searchRoots = getNerdySearchRoots().slice();

    // Nerdy may render a notification next to the embedded form rather than
    // inside it. Include the page document only after submission is armed.
    if (document && searchRoots.indexOf(document) === -1) {
      searchRoots.push(document);
    }

    return searchRoots;
  }

  function getNerdySuccessCandidates(searchRoot) {
    if (!searchRoot || !searchRoot.querySelectorAll) return [];

    var selectors = [
      '[class*="success"]',
      '[class*="thank"]',
      '[class*="submitted"]',
      '[class*="confirmation"]',
      '[data-success]',
      '[data-status="success"]',
      '[role="status"]',
      '[role="alert"]',
      '.alert-success'
    ];

    // Broad text-node scanning is limited to the small Nerdy host/iframe only.
    // Scanning every heading and paragraph in the whole storefront was costly.
    if (searchRoot !== document) {
      selectors.push('h1', 'h2', 'h3', 'h4', 'p');
    }

    var selector = selectors.join(',');

    return Array.from(searchRoot.querySelectorAll(selector)).filter(function (candidate) {
      if (!candidate || candidate === nerdySuccess) return false;
      var text = String(candidate.textContent || candidate.value || '').trim();
      return text.length > 0 && text.length <= 1200;
    });
  }

  function isNerdySuccessText(text) {
    var normalized = normalizeNerdyText(text);
    if (!normalized) return false;

    return (
      normalized.indexOf('request submitted successfully') !== -1 ||
      normalized.indexOf('form submitted successfully') !== -1 ||
      normalized.indexOf('successfully submitted') !== -1 ||
      normalized.indexOf('submission successful') !== -1 ||
      normalized.indexOf('submission received') !== -1 ||
      normalized.indexOf('response received') !== -1 ||
      normalized.indexOf('response has been submitted') !== -1 ||
      normalized.indexOf('response has been recorded') !== -1 ||
      normalized.indexOf('message sent successfully') !== -1 ||
      normalized.indexOf('thank you for your submission') !== -1 ||
      normalized.indexOf('thank you for sharing your device details') !== -1 ||
      /^thank you\b/.test(normalized)
    );
  }

  function isNerdyErrorText(text) {
    var normalized = normalizeNerdyText(text);
    if (!normalized) return false;

    return (
      normalized.indexOf('error') !== -1 ||
      normalized.indexOf('failed') !== -1 ||
      normalized.indexOf('could not') !== -1 ||
      normalized.indexOf('try again') !== -1 ||
      normalized.indexOf('required') !== -1 ||
      normalized.indexOf('invalid') !== -1 ||
      normalized.indexOf('too large') !== -1 ||
      normalized.indexOf('not uploaded') !== -1
    );
  }

  function isNerdyLoadingText(text) {
    var normalized = normalizeNerdyText(text);
    if (!normalized) return false;

    return (
      normalized === 'loading' ||
      normalized.indexOf('loading secure upload form') !== -1 ||
      normalized.indexOf('uploading') !== -1 ||
      normalized.indexOf('submitting') !== -1 ||
      normalized.indexOf('please wait') !== -1
    );
  }

  function countNerdyFields(searchRoots) {
    var uniqueControls = [];

    (searchRoots || []).forEach(function (searchRoot) {
      if (!searchRoot || !searchRoot.querySelectorAll) return;

      Array.from(searchRoot.querySelectorAll('input, textarea, select')).forEach(function (control) {
        var type = String(control.getAttribute('type') || '').toLowerCase();
        if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'reset') return;
        if (uniqueControls.indexOf(control) === -1) uniqueControls.push(control);
      });
    });

    return uniqueControls.length;
  }

  function getVisibleNerdyHostText() {
    if (!nerdyHost) return '';

    var textParts = [];
    var elements = Array.from(nerdyHost.querySelectorAll('h1, h2, h3, h4, p, div, span'));

    elements.forEach(function (element) {
      if (!isElementVisible(element)) return;
      var text = normalizeNerdyText(element.textContent || '');
      if (!text || text.length > 1200) return;
      textParts.push(text);
    });

    return textParts.join(' ').replace(/\s+/g, ' ').trim();
  }

  function hideNerdyDefaultSuccessUi() {
    getNerdySearchRoots().forEach(function (searchRoot) {
      getNerdySuccessCandidates(searchRoot).forEach(function (candidate) {
        if (!candidate || candidate === nerdySuccess) return;
        var text = normalizeNerdyText(candidate.textContent || candidate.value || '');
        if (isNerdySuccessText(text)) hideNerdyElement(candidate);
      });
    });
  }

  function hideStaleNerdySuccessUi() {
    if (!nerdyHost || nerdySubmissionPending || successShown) return;

    getNerdySearchRoots().forEach(function (searchRoot) {
      getNerdySuccessCandidates(searchRoot).forEach(function (candidate) {
        if (!candidate || candidate === nerdySuccess) return;
        var text = normalizeNerdyText(candidate.textContent || candidate.value || '');
        if (isNerdySuccessText(text)) hideNerdyElement(candidate);
      });
    });
  }

  function hideNerdyElement(element) {
    if (!element || !element.style) return;
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
  }

  function clearNerdySuccessTimers() {
    if (nerdySuccessCheckTimer) {
      window.clearInterval(nerdySuccessCheckTimer);
      nerdySuccessCheckTimer = null;
    }

    if (nerdySuccessTimeoutTimer) {
      window.clearTimeout(nerdySuccessTimeoutTimer);
      nerdySuccessTimeoutTimer = null;
    }
  }

  function resetNerdySuccessState() {
    successShown = false;
    nerdySubmissionPending = false;
    nerdySubmissionStartedAt = 0;
    nerdyPreSubmitFieldCount = 0;
    clearNerdySuccessTimers();
    root.classList.remove('is-submitted');

    if (nerdySuccess) {
      nerdySuccess.hidden = true;
      nerdySuccess.setAttribute('hidden', '');
      nerdySuccess.style.setProperty('display', 'none', 'important');
    }

    if (formFlow) {
      formFlow.hidden = false;
      formFlow.removeAttribute('hidden');
      formFlow.style.removeProperty('display');
    }

    if (nerdyHost) {
      nerdyHost.hidden = false;
      nerdyHost.removeAttribute('hidden');
      nerdyHost.style.removeProperty('display');
    }

    hideStaleNerdySuccessUi();
  }

  function showNerdySuccess() {
    if (successShown || !nerdySubmissionPending) return;

    successShown = true;
    nerdySubmissionPending = false;
    nerdySubmissionStartedAt = 0;
    nerdyPreSubmitFieldCount = 0;
    clearNerdySuccessTimers();
    root.classList.add('is-submitted');

    if (nerdyPollTimer) {
      window.clearInterval(nerdyPollTimer);
      nerdyPollTimer = null;
    }

    if (nerdyLoading) nerdyLoading.hidden = true;

    if (nerdyHost) {
      nerdyHost.hidden = true;
      nerdyHost.setAttribute('hidden', '');
      nerdyHost.style.setProperty('display', 'none', 'important');
    }

    if (formFlow) {
      formFlow.hidden = true;
      formFlow.setAttribute('hidden', '');
      formFlow.style.setProperty('display', 'none', 'important');
    }

    if (nerdySuccess) {
      nerdySuccess.hidden = false;
      nerdySuccess.removeAttribute('hidden');
      nerdySuccess.style.setProperty('display', 'flex', 'important');
    }

    clearNotice();

    var target = nerdySuccess || root;
    window.setTimeout(function () {
      var topOffset = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: Math.max(0, topOffset), behavior: 'smooth' });
    }, 50);
  }

  function isElementVisible(element) {
    if (!element || element.hidden) return false;
    var style = element.ownerDocument.defaultView.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    return element.getClientRects().length > 0;
  }

  function normalizeNerdyText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function createSubmissionReference() {
    var date = new Date();
    var year = String(date.getFullYear());
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var random = Math.random().toString(36).slice(2, 8).toUpperCase();
    return 'MRM-' + year + month + day + '-' + random;
  }

  function normalizeCatalogData(source) {
    if (!source || !Array.isArray(source.products)) {
      return source && typeof source === 'object' ? source : {};
    }

    var normalized = {};
    var requiredTag = String(catalogSettings.requiredTag || '').trim().toLowerCase();
    var onlyTagged = catalogSettings.onlyTaggedProducts === true;
    var includeUnclassified = catalogSettings.includeUnclassifiedProducts === true;
    var fallbackPercent = Number(catalogSettings.fallbackSellValuePercentage || 0);

    source.products.forEach(function (product) {
      if (!product || !product.title) return;

      var tags = Array.isArray(product.tags) ? product.tags.map(String) : [];
      var lowerTags = tags.map(function (tag) { return tag.toLowerCase(); });

      if (onlyTagged && requiredTag && lowerTags.indexOf(requiredTag) === -1) return;

      var categoryKey = inferCategory(product, lowerTags);
      if (categoryKey !== 'phone') return;

      var brand = inferBrand(product, lowerTags, categoryKey);
      if (!brand || (brand.key !== 'apple' && brand.key !== 'samsung')) return;

      var categoryMeta = getCategoryMeta(categoryKey);
      if (!normalized[categoryKey]) {
        normalized[categoryKey] = {
          label: categoryMeta.label,
          icon: categoryMeta.icon,
          helper: categoryMeta.helper,
          brands: {}
        };
      }

      var brandLabel = brand.label;
      var brandKey = brand.key;
      if (!normalized[categoryKey].brands[brandKey]) {
        normalized[categoryKey].brands[brandKey] = {
          label: brandLabel,
          icon: getBrandIcon(brandLabel),
          models: []
        };
      }

      var productSellValue = parseMoneyValue(product.productSellValue);
      var rawVariants = Array.isArray(product.variants) ? product.variants.map(function (variant, variantIndex) {
        var explicitValue = parseMoneyValue(variant.sellValue);
        if (explicitValue === null) explicitValue = productSellValue;

        var retailPrice = parseMoneyValue(variant.retailPrice);
        var calculatedValue = explicitValue;
        if (calculatedValue === null && fallbackPercent > 0 && retailPrice !== null) {
          calculatedValue = retailPrice * (fallbackPercent / 100);
        }

        var rawTitle = String(variant.title || '').trim();
        var label = rawTitle && rawTitle.toLowerCase() !== 'default title' ? rawTitle : 'Standard';

        return {
          key: String(variant.id || product.handle + '-' + variantIndex),
          label: label,
          price: calculatedValue,
          retailPrice: retailPrice,
          sku: String(variant.sku || ''),
          available: variant.available !== false
        };
      }) : [];

      if (!rawVariants.length) {
        rawVariants.push({
          key: String(product.id || product.handle || product.title),
          label: 'Standard',
          price: productSellValue,
          retailPrice: null,
          sku: '',
          available: true
        });
      }

      var variants = collapseVariantsToMemory(rawVariants, product.title);
      var seriesLabel = inferSeries(product, lowerTags, brandLabel, categoryKey);
      var familyTitle = normalizeModelFamilyTitle(String(product.title), brandLabel, categoryKey);

      var model = {
        key: slugify(seriesLabel + '-' + familyTitle),
        title: familyTitle,
        series: seriesLabel,
        image: product.image ? String(product.image) : '',
        url: product.url ? String(product.url) : '',
        sourceTitle: String(product.title || ''),
        priority: getModelSourcePriority(String(product.title || '')),
        skuSearch: variants.map(function (variant) { return variant.sku; }).join(' '),
        variants: variants,
        colors: extractColorOptions(rawVariants, product.title)
      };

      normalized[categoryKey].brands[brandKey].models.push(model);
    });

    Object.keys(normalized).forEach(function (categoryKey) {
      var brands = normalized[categoryKey].brands;
      Object.keys(brands).forEach(function (brandKey) {
        brands[brandKey].models = mergeModelFamilies(brands[brandKey].models);
        brands[brandKey].models.sort(function (a, b) {
          if (brandKey === 'samsung') return compareSamsungModelTitles(a.title, b.title);
          return naturalCompare(a.title, b.title);
        });
      });
    });

    return sortCatalog(normalized);
  }

  function collapseVariantsToMemory(variants, productTitle) {
    var grouped = {};

    variants.forEach(function (variant) {
      var memoryLabel = extractMemoryLabel(variant.label) || extractMemoryLabel(productTitle) || 'Standard';
      var memoryKey = slugify(memoryLabel) || 'standard';
      var candidate = {
        key: String(variant.key || memoryKey),
        label: memoryLabel,
        price: variant.price,
        retailPrice: variant.retailPrice,
        sku: String(variant.sku || ''),
        available: variant.available !== false
      };

      if (!grouped[memoryKey] || (!grouped[memoryKey].available && candidate.available)) {
        grouped[memoryKey] = candidate;
      }
    });

    return Object.keys(grouped)
      .map(function (key) { return grouped[key]; })
      .sort(function (a, b) { return compareMemoryLabels(a.label, b.label); });
  }


  function mergeModelFamilies(models) {
    var grouped = {};

    models.forEach(function (model) {
      var groupKey = slugify((model.series || '') + '-' + (model.title || model.key || 'model'));
      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          key: groupKey,
          title: model.title,
          series: model.series,
          image: model.image || '',
          url: model.url || '',
          sourceTitle: model.sourceTitle || '',
          priority: Number(model.priority || 0),
          skuSearch: model.skuSearch || '',
          variants: [],
          colors: []
        };
      }

      var target = grouped[groupKey];
      if (Number(model.priority || 0) > Number(target.priority || 0)) {
        target.image = model.image || target.image;
        target.url = model.url || target.url;
        target.sourceTitle = model.sourceTitle || target.sourceTitle;
        target.priority = Number(model.priority || 0);
      }

      target.skuSearch = [target.skuSearch, model.skuSearch].filter(Boolean).join(' ');
      target.variants = mergeMemoryVariants(target.variants, model.variants || []);
      target.colors = uniqueNatural(target.colors.concat(model.colors || []));
    });

    return Object.keys(grouped).map(function (key) {
      var model = grouped[key];
      model.variants.sort(function (a, b) { return compareMemoryLabels(a.label, b.label); });
      model.colors.sort(naturalCompare);
      return model;
    });
  }

  function mergeMemoryVariants(existing, incoming) {
    var grouped = {};

    existing.concat(incoming).forEach(function (variant) {
      var key = slugify(variant.label || variant.key || 'standard');
      if (!grouped[key] || (!grouped[key].available && variant.available)) {
        grouped[key] = variant;
      }
    });

    return Object.keys(grouped).map(function (key) { return grouped[key]; });
  }

  function uniqueNatural(values) {
    var seen = {};
    var result = [];

    values.forEach(function (value) {
      var clean = String(value || '').trim();
      var key = clean.toLowerCase();
      if (!clean || seen[key]) return;
      seen[key] = true;
      result.push(clean);
    });

    return result;
  }

  function normalizeModelFamilyTitle(title, brandLabel, categoryKey) {
    var cleaned = cleanModelTitle(title, brandLabel)
      .replace(/\bpre[-\s]?owned\b/gi, '')
      .replace(/\brefurbished\b/gi, '')
      .replace(/\bused\b/gi, '')
      .replace(/\b(?:tdra\/?uae|international|usa|japan|middle east|global version|uae version)\b/gi, '')
      .replace(/\b(?:e[-\s]?sim|physical sim|dual sim)\b/gi, '')
      .replace(/\b\d+(?:\.\d+)?\s*(?:TB|GB)\b/gi, '')
      .replace(/[()\[\]\/|_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    var match;
    if (brandLabel === 'Apple' && categoryKey === 'phone') {
      match = cleaned.match(/iPhone\s+(?:SE(?:\s+\d+)?|\d+(?:\s*(?:Pro Max|Pro|Plus|Mini|Air|e))?)/i);
      if (match) {
        return match[0]
          .replace(/^iphone/i, 'iPhone')
          .replace(/pro max/i, 'Pro Max')
          .replace(/pro/i, 'Pro')
          .replace(/plus/i, 'Plus')
          .replace(/mini/i, 'Mini')
          .replace(/air/i, 'Air')
          .replace(/\s+/g, ' ')
          .trim();
      }
    }

    if (brandLabel === 'Samsung' && categoryKey === 'phone') {
      match = cleaned.match(/(?:Samsung\s+)?(?:Galaxy\s+)?S(\d{2})(?:\s*(Ultra|Plus|\+|FE|Edge))?/i);
      if (match) {
        var sSuffix = String(match[2] || '').replace(/^\+$/, 'Plus');
        return 'Samsung Galaxy S' + match[1] + (sSuffix ? ' ' + titleCase(sSuffix) : '');
      }

      match = cleaned.match(/(?:Samsung\s+)?(?:Galaxy\s+)?(?:Z\s*)?(Fold|Flip)\s*(\d+)/i);
      if (match) {
        return 'Samsung Galaxy Z ' + titleCase(match[1]) + ' ' + match[2];
      }

      match = cleaned.match(/(?:Samsung\s+)?(?:Galaxy\s+)?(A\d+|M\d+|F\d+|Note\s*\d+)/i);
      if (match) {
        return 'Samsung Galaxy ' + String(match[1]).replace(/\s+/g, ' ').trim();
      }
    }

    if (brandLabel === 'Google' && categoryKey === 'phone') {
      match = cleaned.match(/Pixel\s+\d+(?:\s*(?:Pro XL|Pro|a|Fold))?/i);
      if (match) return match[0].replace(/^pixel/i, 'Pixel').replace(/\s+/g, ' ').trim();
    }

    return cleaned || cleanModelTitle(title, brandLabel);
  }

  function getModelSourcePriority(title) {
    var text = String(title || '').toLowerCase();
    var score = 0;
    if (!/pre[-\s]?owned|refurbished|used/.test(text)) score += 30;
    if (!/\d+(?:\.\d+)?\s*(?:tb|gb)\b/.test(text)) score += 20;
    if (!/tdra|international|usa|japan|e[-\s]?sim|dual sim/.test(text)) score += 10;
    return score;
  }

  function extractColorOptions(variants, productTitle) {
    var variantValues = [];
    (variants || []).forEach(function (variant) {
      variantValues.push(String(variant.label || ''));
    });
    var values = variantValues.concat([String(productTitle || '')]);

    var detected = [];
    var rules = [
      ['Natural Titanium', /\bnatural titanium\b/i],
      ['Desert Titanium', /\bdesert titanium\b/i],
      ['Black Titanium', /\bblack titanium\b/i],
      ['White Titanium', /\bwhite titanium\b/i],
      ['Blue Titanium', /\bblue titanium\b/i],
      ['Rose Gold', /\brose gold\b/i],
      ['Space Gray', /\bspace gr[ae]y\b/i],
      ['Sierra Blue', /\bsierra blue\b/i],
      ['Alpine Green', /\balpine green\b/i],
      ['Product Red', /\bproduct\s*red\b|\b\(red\)\b/i],
      ['Graphite', /\bgraphite\b/i],
      ['Starlight', /\bstarlight\b/i],
      ['Midnight', /\bmidnight\b/i],
      ['Cream', /\bcream\b/i],
      ['Lavender', /\blavender\b/i],
      ['Mint', /\bmint\b/i],
      ['Coral', /\bcoral\b/i],
      ['Bronze', /\bbronze\b/i],
      ['Orange', /\borange\b/i],
      ['Purple', /\bpurple\b/i],
      ['Yellow', /\byellow\b/i],
      ['Green', /\bgreen\b/i],
      ['Blue', /\bblue\b/i],
      ['Pink', /\bpink\b/i],
      ['Red', /\bred\b/i],
      ['Gold', /\bgold\b/i],
      ['Silver', /\bsilver\b/i],
      ['Gray', /\bgr[ae]y\b/i],
      ['White', /\bwhite\b/i],
      ['Black', /\bblack\b/i]
    ];

    values.forEach(function (value) {
      rules.forEach(function (rule) {
        if (rule[1].test(value)) detected.push(rule[0]);
      });
    });

    variantValues.forEach(function (value) {
      var firstPart = value.split('/')[0].trim();
      if (
        firstPart &&
        firstPart.length <= 28 &&
        !/\d+\s*(?:tb|gb)|tdra|international|usa|japan|sim|standard|default/i.test(firstPart)
      ) {
        detected.push(titleCase(firstPart));
      }
    });

    return uniqueNatural(detected);
  }

  function extractMemoryLabel(value) {
    var text = String(value || '');
    var matches = [];
    var pattern = /(\d+(?:\.\d+)?)\s*(TB|GB)\b/gi;
    var match;

    while ((match = pattern.exec(text)) !== null) {
      var amount = Number(match[1]);
      var unit = String(match[2] || '').toUpperCase();
      if (!isFinite(amount) || amount <= 0) continue;

      matches.push({
        label: formatMemoryAmount(amount) + unit,
        gb: unit === 'TB' ? amount * 1024 : amount
      });
    }

    if (!matches.length) return '';

    matches.sort(function (a, b) {
      return b.gb - a.gb;
    });

    return matches[0].label;
  }

  function formatMemoryAmount(amount) {
    if (Math.floor(amount) === amount) return String(amount);
    return String(amount).replace(/\.0+$/, '');
  }

  function compareMemoryLabels(a, b) {
    var aValue = memoryLabelToGb(a);
    var bValue = memoryLabelToGb(b);

    if (aValue !== null && bValue !== null) return aValue - bValue;
    if (aValue !== null) return -1;
    if (bValue !== null) return 1;
    return naturalCompare(a, b);
  }

  function memoryLabelToGb(label) {
    var match = String(label || '').match(/(\d+(?:\.\d+)?)\s*(TB|GB)\b/i);
    if (!match) return null;

    var amount = Number(match[1]);
    if (!isFinite(amount)) return null;
    return String(match[2]).toUpperCase() === 'TB' ? amount * 1024 : amount;
  }

  function isOfficialMobileSourceCollection(sourceCollection) {
    var handle = String(sourceCollection || '').trim().toLowerCase();
    return (
      /^iphone-(?:17|16|15|14|13|12|11)-series$/.test(handle) ||
      /^samsung-(?:fold|s26|s25|s24|s23|s22|s21)-series$/.test(handle)
    );
  }

  function isExpectedProductForSourceCollection(product) {
    var handle = String(product && product.sourceCollection || '').trim().toLowerCase();
    var title = String(product && product.title || '').replace(/\s+/g, ' ').trim();

    if (!handle) return true;

    var iphoneMatch = handle.match(/^iphone-(17|16|15|14|13|12|11)-series$/);
    if (iphoneMatch) {
      return new RegExp('\\biPhone\\s*' + iphoneMatch[1] + '\\b', 'i').test(title);
    }

    if (handle === 'samsung-fold-series') {
      return /\b(?:Samsung\s+)?(?:Galaxy\s+)?(?:Z\s*)?(?:Fold|Flip)\s*\d+\b/i.test(title);
    }

    var samsungMatch = handle.match(/^samsung-s(26|25|24|23|22|21)-series$/);
    if (samsungMatch) {
      return new RegExp(
        '\\b(?:Samsung\\s+)?(?:Galaxy\\s+)?S' + samsungMatch[1] +
        '(?:\\s*(?:Ultra|Plus|\\+|FE|Edge))?\\b',
        'i'
      ).test(title);
    }

    return true;
  }

  function inferCategory(product, lowerTags) {
    var sourceCollection = String(product.sourceCollection || '').trim().toLowerCase();
    if (isOfficialMobileSourceCollection(sourceCollection)) return 'phone';

    var haystack = [product.title, product.productType, lowerTags.join(' ')].join(' ').toLowerCase();

    if (containsAny(haystack, ['case', 'cover', 'charger', 'charging', 'cable', 'adapter', 'screen protector', 'protector', 'tempered glass', 'lens protector', 'strap', 'band', 'power bank', 'earbuds', 'ear buds', 'airpods', 'headphone', 'headset', 'mouse', 'keyboard', 'stand', 'holder'])) {
      return '';
    }

    if (containsAny(haystack, ['playstation', 'ps5', 'ps4', 'xbox', 'nintendo switch', 'gaming console', 'game console', 'console'])) return 'gaming_console';
    if (containsAny(haystack, ['smart watch', 'smartwatch', 'apple watch', 'galaxy watch', 'watch ultra', 'pixel watch'])) return 'smartwatch';
    if (containsAny(haystack, ['macbook', 'laptop', 'notebook', 'chromebook', 'xps ', 'thinkpad', 'ideapad', 'vivobook', 'zenbook'])) return 'laptop';
    if (containsAny(haystack, ['ipad', 'tablet', 'galaxy tab', 'surface pro', 'surface go', 'xiaomi pad', 'redmi pad', 'oneplus pad'])) return 'tablet';

    var explicit = normalizeCategoryName(product.deviceCategory);
    if (explicit) return explicit;

    for (var i = 0; i < lowerTags.length; i++) {
      var tagCategory = normalizeCategoryName(lowerTags[i].replace(/^device[:\-_ ]*/, ''));
      if (tagCategory) return tagCategory;
    }

    if (containsAny(haystack, ['iphone', 'smartphone', 'mobile phone', 'phone', 'pixel', 'oneplus', 'one plus', 'galaxy s', 'galaxy z', 'galaxy a', 'galaxy m', 'galaxy f', 'vivo', 'oppo', 'nokia', 'motorola', 'huawei', 'honor', 'redmagic', 'red magic', 'tecno', 'infinix', 'realme', 'xiaomi', 'redmi', 'poco', 'nothing phone', 'cmf phone', 'asus rog'])) return 'phone';

    return '';
  }

  function normalizeCategoryName(value) {
    var normalized = String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ');
    if (!normalized) return '';
    if (containsAny(normalized, ['gaming console', 'game console', 'console', 'playstation', 'xbox'])) return 'gaming_console';
    if (containsAny(normalized, ['smartwatch', 'smart watch', 'watch'])) return 'smartwatch';
    if (containsAny(normalized, ['laptop', 'notebook', 'macbook'])) return 'laptop';
    if (containsAny(normalized, ['tablet', 'ipad', 'tab'])) return 'tablet';
    if (containsAny(normalized, ['phone', 'mobile', 'smartphone'])) return 'phone';
    if (containsAny(normalized, ['other device', 'other'])) return 'other';
    return '';
  }

  function inferBrand(product, lowerTags, categoryKey) {
    var sourceCollection = String(product.sourceCollection || '').trim().toLowerCase();

    if (/^iphone-(?:17|16|15|14|13|12|11)-series$/.test(sourceCollection)) {
      return { key: 'apple', label: 'Apple' };
    }

    if (/^samsung-(?:fold|s26|s25|s24|s23|s22|s21)-series$/.test(sourceCollection)) {
      return { key: 'samsung', label: 'Samsung' };
    }

    var explicitBrand = String(product.deviceBrand || '').trim();
    var taggedBrand = '';

    for (var i = 0; i < lowerTags.length; i++) {
      var tag = lowerTags[i];
      if (tag.indexOf('brand:') === 0) {
        taggedBrand = tag.slice(6).trim();
        break;
      }
      if (tag.indexOf('brand-') === 0) {
        taggedBrand = tag.slice(6).replace(/-/g, ' ').trim();
        break;
      }
    }

    var titleAndType = [product.title, product.productType, lowerTags.join(' ')].join(' ');
    var detected = canonicalBrandFromText(titleAndType, categoryKey);
    if (detected) return detected;

    detected = canonicalBrandFromText([explicitBrand, taggedBrand].join(' '), categoryKey);
    if (detected) return detected;

    var vendor = String(product.vendor || '').trim();
    if (vendor && !isStoreVendor(vendor) && !/^other$/i.test(vendor)) {
      detected = canonicalBrandFromText(vendor, categoryKey);
      if (detected) return detected;

      return {
        key: slugify(vendor),
        label: titleCase(vendor)
      };
    }

    return null;
  }

  function canonicalBrandFromText(value, categoryKey) {
    var text = String(value || '').toLowerCase();
    if (!text) return null;

    var brandRules = [
      { key: 'apple', label: 'Apple', test: /\bapple\b|\biphone\b|\bipad\b|\bmacbook\b|\bapple\s*watch\b/ },
      { key: 'samsung', label: 'Samsung', test: /\bsamsung\b|\bgalaxy\s+(?:s|z|a|m|f|note|tab|watch)\b/ },
      { key: 'google', label: 'Google', test: /\bgoogle\b|\bpixel\s*(?:phone|watch|tablet|fold|\d)/ },
      { key: 'oneplus', label: 'OnePlus', test: /\bone\s*plus\b|\boneplus\b/ },
      { key: 'xiaomi', label: 'Xiaomi', test: /\bxiaomi\b|\bmi\s+\d/ },
      { key: 'redmi', label: 'Redmi', test: /\bredmi\b/ },
      { key: 'poco', label: 'POCO', test: /\bpoco\b/ },
      { key: 'oppo', label: 'OPPO', test: /\boppo\b/ },
      { key: 'vivo', label: 'Vivo', test: /\bvivo\b/ },
      { key: 'huawei', label: 'Huawei', test: /\bhuawei\b/ },
      { key: 'honor', label: 'Honor', test: /\bhonor\b/ },
      { key: 'realme', label: 'Realme', test: /\brealme\b/ },
      { key: 'nothing', label: 'Nothing', test: /\bnothing\s+phone\b|\bnothing\b/ },
      { key: 'cmf', label: 'CMF', test: /\bcmf\b/ },
      { key: 'motorola', label: 'Motorola', test: /\bmotorola\b|\bmoto\s+[a-z0-9]/ },
      { key: 'nokia', label: 'Nokia', test: /\bnokia\b/ },
      { key: 'sony', label: 'Sony', test: /\bsony\b|\bxperia\b|\bplaystation\b|\bps[45]\b/ },
      { key: 'asus', label: 'ASUS', test: /\basus\b|\brog\s+phone\b|\bzenfone\b/ },
      { key: 'tecno', label: 'Tecno', test: /\btecno\b/ },
      { key: 'infinix', label: 'Infinix', test: /\binfinix\b/ },
      { key: 'zte', label: 'ZTE', test: /\bzte\b/ },
      { key: 'nubia', label: 'Nubia', test: /\bnubia\b/ },
      { key: 'redmagic', label: 'RedMagic', test: /\bred\s*magic\b|\bredmagic\b/ },
      { key: 'microsoft', label: 'Microsoft', test: /\bmicrosoft\b|\bxbox\b|\bsurface\b/ },
      { key: 'dell', label: 'Dell', test: /\bdell\b|\bxps\b|\binspiron\b/ },
      { key: 'hp', label: 'HP', test: /\bhp\b|\bpavilion\b|\benvy\b|\bspectre\b/ },
      { key: 'lenovo', label: 'Lenovo', test: /\blenovo\b|\bthinkpad\b|\bideapad\b/ },
      { key: 'acer', label: 'Acer', test: /\bacer\b|\baspire\b/ },
      { key: 'nintendo', label: 'Nintendo', test: /\bnintendo\b|\bswitch\b/ }
    ];

    for (var i = 0; i < brandRules.length; i++) {
      if (brandRules[i].test.test(text)) return { key: brandRules[i].key, label: brandRules[i].label };
    }

    return null;
  }

  function isStoreVendor(value) {
    var compact = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    return compact === 'mrmobile' || compact === 'mrmobilea' || compact === 'mrmobiles' || compact === 'mrmobileuae';
  }

  function inferSeries(product, lowerTags, brandLabel, categoryKey) {
    var title = String(product.title || '').replace(/\s+/g, ' ').trim();
    var sourceCollection = String(product.sourceCollection || '').trim().toLowerCase();
    var match;

    if (sourceCollection) {
      match = sourceCollection.match(/^iphone-(17|16|15|14|13|12|11)-series$/);
      if (match) return 'iPhone ' + match[1] + ' Series';

      if (sourceCollection === 'samsung-fold-series') return 'Samsung Fold Series';

      match = sourceCollection.match(/^samsung-s(26|25|24|23|22|21)-series$/);
      if (match) return 'Samsung S' + match[1] + ' Series';
    }

    match = title.match(/iphone\s+(\d+)/i);
    if (match) return 'iPhone ' + match[1] + ' Series';

    match = title.match(/(?:galaxy\s+|samsung\s+)?s(\d{2})\b/i);
    if (match && /samsung|galaxy/i.test(title)) return 'Samsung S' + match[1] + ' Series';

    if (/galaxy\s+z\s*fold/i.test(title) || /\bz\s*fold\b/i.test(title)) return 'Samsung Fold Series';
    if (/galaxy\s+z\s*flip/i.test(title) || /\bz\s*flip\b/i.test(title)) return 'Galaxy Z Flip Series';
    if (/galaxy\s+note\s*\d+/i.test(title)) return 'Galaxy Note Series';
    if (/galaxy\s+a\d+/i.test(title) || /samsung\s+a\d+/i.test(title)) return 'Galaxy A Series';
    if (/galaxy\s+m\d+/i.test(title) || /samsung\s+m\d+/i.test(title)) return 'Galaxy M Series';
    if (/galaxy\s+f\d+/i.test(title) || /samsung\s+f\d+/i.test(title)) return 'Galaxy F Series';

    match = title.match(/pixel\s+(\d+)/i);
    if (match) return 'Pixel ' + match[1] + ' Series';

    match = title.match(/one\s*plus\s+(\d+)/i);
    if (match) return 'OnePlus ' + match[1] + ' Series';

    match = title.match(/xiaomi\s+(\d+)/i);
    if (match) return 'Xiaomi ' + match[1] + ' Series';
    if (/redmi\s+note/i.test(title)) return 'Redmi Note Series';
    if (/redmi\s+[a-z]?\d+/i.test(title)) return 'Redmi Series';
    if (/poco\s+x/i.test(title)) return 'POCO X Series';
    if (/poco\s+f/i.test(title)) return 'POCO F Series';
    if (/poco\s+m/i.test(title)) return 'POCO M Series';
    if (/oppo\s+reno/i.test(title)) return 'OPPO Reno Series';
    if (/oppo\s+find/i.test(title)) return 'OPPO Find Series';
    if (/oppo\s+a\d+/i.test(title)) return 'OPPO A Series';
    if (/vivo\s+x/i.test(title)) return 'Vivo X Series';
    if (/vivo\s+v/i.test(title)) return 'Vivo V Series';
    if (/vivo\s+y/i.test(title)) return 'Vivo Y Series';
    if (/huawei\s+mate/i.test(title)) return 'Huawei Mate Series';
    if (/huawei\s+pura/i.test(title)) return 'Huawei Pura Series';
    if (/huawei\s+p\d+/i.test(title)) return 'Huawei P Series';
    if (/honor\s+magic/i.test(title)) return 'Honor Magic Series';
    if (/honor\s+x/i.test(title)) return 'Honor X Series';
    if (/realme\s+gt/i.test(title)) return 'Realme GT Series';
    if (/realme\s+\d+/i.test(title)) return 'Realme Number Series';
    if (/nothing\s+phone/i.test(title)) return 'Nothing Phone Series';
    if (/motorola\s+edge/i.test(title)) return 'Motorola Edge Series';
    if (/motorola\s+razr/i.test(title)) return 'Motorola Razr Series';

    if (/ipad\s+pro/i.test(title)) return 'iPad Pro';
    if (/ipad\s+air/i.test(title)) return 'iPad Air';
    if (/ipad\s+mini/i.test(title)) return 'iPad mini';
    if (/ipad/i.test(title)) return 'iPad';
    if (/galaxy\s+tab\s+s/i.test(title)) return 'Galaxy Tab S Series';
    if (/galaxy\s+tab\s+a/i.test(title)) return 'Galaxy Tab A Series';
    if (/macbook\s+pro/i.test(title)) return 'MacBook Pro';
    if (/macbook\s+air/i.test(title)) return 'MacBook Air';
    if (/apple\s+watch\s+ultra/i.test(title)) return 'Apple Watch Ultra';
    if (/apple\s+watch/i.test(title)) return 'Apple Watch Series';
    if (/galaxy\s+watch/i.test(title)) return 'Galaxy Watch Series';
    if (/playstation\s*5|\bps5\b/i.test(title)) return 'PlayStation 5';
    if (/playstation\s*4|\bps4\b/i.test(title)) return 'PlayStation 4';
    if (/xbox\s+series\s+x/i.test(title)) return 'Xbox Series X';
    if (/xbox\s+series\s+s/i.test(title)) return 'Xbox Series S';
    if (/nintendo\s+switch/i.test(title)) return 'Nintendo Switch';

    if (product.series) return normalizeSeriesLabel(product.series);

    for (var i = 0; i < lowerTags.length; i++) {
      var tag = lowerTags[i];
      if (tag.indexOf('series:') === 0) return normalizeSeriesLabel(tag.slice(7));
      if (tag.indexOf('series-') === 0) return normalizeSeriesLabel(tag.slice(7).replace(/-/g, ' '));
    }

    var productType = String(product.productType || '').trim();
    if (productType && !/^(mobile|phone|smartphone|tablet|laptop|watch|console)$/i.test(productType)) {
      return normalizeSeriesLabel(productType);
    }

    return brandLabel + (categoryKey === 'phone' ? ' Phones' : ' Models');
  }

  function normalizeSeriesLabel(value) {
    var label = String(value || '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!label) return 'Other Models';

    var iphone = label.match(/^iphone\s+(\d+)(?:\s+series)?$/i);
    if (iphone) return 'iPhone ' + iphone[1] + ' Series';

    var galaxyS = label.match(/^(?:galaxy\s+)?s(\d+)(?:\s+series)?$/i);
    if (galaxyS) return 'Galaxy S' + galaxyS[1] + ' Series';

    return titleCase(label)
      .replace(/Iphone/g, 'iPhone')
      .replace(/Ipad/g, 'iPad')
      .replace(/Macbook/g, 'MacBook')
      .replace(/Oneplus/g, 'OnePlus')
      .replace(/Oppo/g, 'OPPO')
      .replace(/Poco/g, 'POCO');
  }

  function cleanModelTitle(title, brandLabel) {
    var cleaned = String(title || '').replace(/\s+/g, ' ').trim();
    if (!cleaned) return cleaned;

    if (brandLabel === 'Apple') {
      cleaned = cleaned.replace(/^apple\s+/i, '');
      cleaned = cleaned.replace(/^iphone/i, 'iPhone');
    }

    return cleaned;
  }

  function compareSamsungModelTitles(a, b) {
    function rank(value) {
      var text = String(value || '');
      if (/\bUltra\b/i.test(text)) return 50;
      if (/\bEdge\b/i.test(text)) return 40;
      if (/\bFE\b/i.test(text)) return 30;
      if (/\bPlus\b|\+/i.test(text)) return 20;
      return 10;
    }

    var aNumber = extractSeriesNumber(a);
    var bNumber = extractSeriesNumber(b);

    if (aNumber !== null && bNumber !== null && aNumber !== bNumber) {
      return bNumber - aNumber;
    }

    var aRank = rank(a);
    var bRank = rank(b);
    if (aRank !== bRank) return aRank - bRank;

    return naturalCompare(a, b);
  }

  function compareBrandLabels(a, b) {
    var priority = ['Apple', 'Samsung', 'Google', 'OnePlus', 'Xiaomi', 'Redmi', 'POCO', 'OPPO', 'Vivo', 'Huawei', 'Honor', 'Realme', 'Nothing', 'Motorola', 'Nokia', 'Sony'];
    var aIndex = priority.indexOf(a);
    var bIndex = priority.indexOf(b);

    if (aIndex !== -1 || bIndex !== -1) {
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    }

    return naturalCompare(a, b);
  }

  function compareSeriesLabels(a, b) {
    var aNumber = extractSeriesNumber(a);
    var bNumber = extractSeriesNumber(b);

    if (aNumber !== null && bNumber !== null && aNumber !== bNumber) {
      return bNumber - aNumber;
    }
    if (aNumber !== null && bNumber === null) return -1;
    if (aNumber === null && bNumber !== null) return 1;

    return naturalCompare(a, b);
  }

  function extractSeriesNumber(value) {
    var match = String(value || '').match(/(\d{1,3})/);
    return match ? Number(match[1]) : null;
  }

  function getCategoryMeta(categoryKey) {
    var meta = {
      phone: { label: 'Phone', icon: '📱', helper: 'Sell used smartphones' },
      tablet: { label: 'Tablet', icon: '📲', helper: 'Sell used tablets' },
      laptop: { label: 'Laptop', icon: '💻', helper: 'Sell used laptops' },
      smartwatch: { label: 'Smartwatch', icon: '⌚', helper: 'Sell used smartwatches' },
      gaming_console: { label: 'Gaming Console', icon: '🎮', helper: 'Sell used consoles' },
      other: { label: 'Other Device', icon: '📦', helper: 'Sell another supported device' }
    };
    return meta[categoryKey] || meta.other;
  }

  function getBrandIcon(brandLabel) {
    var brand = String(brandLabel || '').trim();
    if (/^apple$/i.test(brand)) return '';
    return brand ? brand.charAt(0).toUpperCase() : '•';
  }

  function parseMoneyValue(value) {
    if (value === null || typeof value === 'undefined' || value === '') return null;
    if (typeof value === 'object' && value.amount !== undefined) value = value.amount;
    var numeric = Number(String(value).replace(/[^0-9.-]/g, ''));
    return isFinite(numeric) ? numeric : null;
  }

  function containsAny(haystack, needles) {
    for (var i = 0; i < needles.length; i++) {
      if (haystack.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function titleCase(value) {
    return String(value || '').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function naturalCompare(a, b) {
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
  }

  function sortCatalog(catalog) {
    var ordered = {};
    ['phone', 'tablet', 'laptop', 'smartwatch', 'gaming_console', 'other'].forEach(function (key) {
      if (catalog[key]) ordered[key] = catalog[key];
    });
    Object.keys(catalog).forEach(function (key) {
      if (!ordered[key]) ordered[key] = catalog[key];
    });
    return ordered;
  }

  function getCurrentDeviceData() {
    if (!state.device || !data[state.device]) return null;
    return data[state.device];
  }

  function getCurrentBrandData() {
    var device = getCurrentDeviceData();
    if (!device || !state.brand || !device.brands[state.brand]) return null;
    return device.brands[state.brand];
  }

  function getCurrentModels() {
    if (state.brand === 'other') return [];
    var phoneData = data.phone;
    if (!phoneData || !phoneData.brands || !phoneData.brands[state.brand]) return [];

    return (phoneData.brands[state.brand].models || []).filter(function (model) {
      return isAllowedModelForBrand(model, state.brand);
    });
  }
  function getFilteredModels() {
    var models = getCurrentModels();
    var hasSearch = !!state.modelSearch;

    if (!state.seriesFilter && !hasSearch) return [];

    return models.filter(function (model) {
      if (!isAllowedModelForBrand(model, state.brand)) return false;
      var matchesSeries = !state.seriesFilter || model.series === state.seriesFilter;
      var haystack = [model.title, model.series, model.skuSearch].join(' ').toLowerCase();
      var matchesSearch = !hasSearch || haystack.indexOf(state.modelSearch) !== -1;
      return matchesSeries && matchesSearch;
    });
  }

  function getCurrentModel() {
    var models = getCurrentModels();
    for (var i = 0; i < models.length; i++) {
      if ((state.modelKey && models[i].key === state.modelKey) || (!state.modelKey && models[i].title === state.modelTitle)) {
        return models[i];
      }
    }
    return null;
  }

  function getCurrentVariant() {
    var model = getCurrentModel();
    if (!model || !model.variants) return null;

    for (var i = 0; i < model.variants.length; i++) {
      if ((state.variantKey && model.variants[i].key === state.variantKey) || (!state.variantKey && model.variants[i].label === state.variantLabel)) {
        return model.variants[i];
      }
    }
    return null;
  }

  function getProductLabel() {
    return 'Mobile Phone';
  }
  function getBrandLabel() {
    if (state.brand === 'other') return state.otherBrand || 'Other';
    if (state.brand === 'apple') return 'Apple';
    if (state.brand === 'samsung') return 'Samsung';
    return '';
  }
  function getSeriesLabel() {
    if (state.brand === 'other') return 'Other / Not listed';
    var model = getCurrentModel();
    if (model && model.series) return model.series;
    return state.seriesFilter || '';
  }
  function getCurrentDeviceIcon() {
    var device = getCurrentDeviceData();
    return device ? device.icon || '📦' : '📦';
  }

  function setThumbContent(element, model) {
    if (!element) return;
    if (model && model.image) {
      element.innerHTML = '<img src="' + escapeHtml(model.image) + '" alt="' + escapeHtml(model.title) + '" loading="lazy">';
    } else {
      element.textContent = getCurrentDeviceIcon();
    }
  }

  function absoluteUrl(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return url;
    }
  }

  function createMetaCard(label, value, attrName, isActive, icon, helper) {
    return '' +
      '<button type="button" class="sell-device__option' + (isActive ? ' is-active' : '') + '" ' + attrName + '="' + escapeHtml(value) + '">' +
        '<span class="sell-device__option-inner">' +
          '<span class="sell-device__option-icon">' + escapeHtml(icon || '') + '</span>' +
          '<span>' +
            '<span class="sell-device__option-title">' + escapeHtml(label) + '</span>' +
            '<span class="sell-device__option-helper">' + escapeHtml(helper || '') + '</span>' +
          '</span>' +
        '</span>' +
      '</button>';
  }

  function makePill(label, value) {
    return '<span class="sell-device__pill"><strong>' + escapeHtml(label) + ':</strong> ' + escapeHtml(value) + '</span>';
  }

  function showNotice(message) {
    if (!notice) return;
    notice.textContent = message;
    notice.classList.add('is-visible');
  }

  function clearNotice() {
    if (!notice) return;
    notice.textContent = '';
    notice.classList.remove('is-visible');
  }

  function scrollToFlow() {
    if (!formFlow || !state.device) return;
    var topOffset = formFlow.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: topOffset, behavior: 'smooth' });
  }

  function scrollToPickupContactForm() {
    var target = nerdyHost || root.querySelector('[data-nerdy-form-host]');
    if (!target) return;

    window.setTimeout(function () {
      var topOffset =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        92;

      window.scrollTo({
        top: Math.max(0, topOffset),
        behavior: 'smooth'
      });
    }, 160);
  }

  function scrollToModelGrid() {
    if (!modelSection || !state.seriesFilter) return;
    window.setTimeout(function () {
      var topOffset =
        modelSection.getBoundingClientRect().top +
        window.pageYOffset -
        105;

      window.scrollTo({
        top: Math.max(0, topOffset),
        behavior: 'smooth'
      });
    }, 90);
  }

  function scrollToDeviceDetailPanel() {
    if (!detailPanel || !state.modelKey) return;

    window.setTimeout(function () {
      var topOffset =
        detailPanel.getBoundingClientRect().top +
        window.pageYOffset -
        105;

      window.scrollTo({
        top: Math.max(0, topOffset),
        behavior: 'smooth'
      });
    }, 90);
  }

  function scrollToSeriesSection() {
    if (!seriesWrap) return;

    window.setTimeout(function () {
      var topOffset =
        seriesWrap.getBoundingClientRect().top +
        window.pageYOffset -
        105;

      window.scrollTo({
        top: Math.max(0, topOffset),
        behavior: 'smooth'
      });
    }, 90);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}
